const currentDate = new Date();

let subscribers = {};
function subscribe(event, cb) {
	if (subscribers[event] === undefined) {
		subscribers[event] = [];
	}
	subscribers[event] = [...subscribers[event], cb];
	return function _0x132295() {
		subscribers[event] = subscribers[event].filter((_0x25e12f) => {
			return _0x25e12f !== cb;
		});
	};
}

function publish(_0x1490c5, _0x2f6a81) {
	if (subscribers[_0x1490c5]) {
		subscribers[_0x1490c5].forEach((_0xde29f9) => {
			_0xde29f9(_0x2f6a81);
		});
	}
}

class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", (_0x56fab6) => {
			_0x56fab6.preventDefault();
			const _0x51dc5c = this.closest("cart-items") || this.closest("cart-drawer-items");
			if (this.clearCart) {
				_0x51dc5c.clearCart();
			} else {
				_0x51dc5c.updateQuantity(this.dataset.index, 0);
			}
		});
	}
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemContainer = true;
		this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
		this.secondCartItems = document.querySelector("cart-drawer-items");
		const _0x14f991 = debounce((_0x38b925) => {
			this.onChange(_0x38b925);
		}, 0x12c);
		if (!this.lineItemContainer) {
			window.routes.cart_add_url = "cart";
		}
		this.addEventListener("change", _0x14f991.bind(this));
	}
	["cartUpdateUnsubscriber"] = undefined;
	["connectedCallback"]() {
		this.cartUpdateUnsubscriber = subscribe("cart-update", (_0x144492) => {
			if (_0x144492.source === "cart-items") {
				return;
			}
			this.onCartUpdate();
		});
	}
	["disconnectedCallback"]() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}
	["onChange"](_0x24a94c) {
		this.updateQuantity(_0x24a94c.target.dataset.index, _0x24a94c.target.value, document.activeElement.getAttribute("name"));
	}
	["onCartUpdate"]() {
		fetch("/cart?section_id=main-cart-items")
			.then((_0x2388ec) => _0x2388ec.text())
			.then((_0x15d282) => {
				const _0x5ac697 = new DOMParser().parseFromString(_0x15d282, "text/html");
				const _0x34e280 = _0x5ac697.querySelector("cart-items");
				this.innerHTML = _0x34e280.innerHTML;
			})
			["catch"]((_0x4b2c49) => {
				console.error(_0x4b2c49);
			});
	}
	["updateCart"]() {
		const _0xe1bb7e = JSON.stringify({
			"sections": this.getSectionsToRender().map((_0xc13c8a) => _0xc13c8a.section),
			"sections_url": window.location.pathname,
		});
		fetch("/cart/update.js", {
			"method": "POST",
			"headers": {
				"Content-Type": "application/json",
			},
			"body": _0xe1bb7e,
		})
			.then((_0x20e1a2) => _0x20e1a2.json())
			.then((_0x1bc14e) => {
				this.classList.toggle("is-empty", _0x1bc14e.item_count === 0);
				this.getSectionsToRender().forEach((_0x232db9) => {
					const _0x3c756b = document.getElementById(_0x232db9.id).querySelector(_0x232db9.selector) || document.getElementById(_0x232db9.id);
					_0x3c756b.innerHTML = this.getSectionInnerHTML(_0x1bc14e.sections[_0x232db9.section], _0x232db9.selector);
				});
			})
			["catch"]((_0x4e8d06) => {
				console.error(_0x4e8d06);
			});
	}
	["getSectionsToRender"]() {
		return [
			{
				"id": "main-cart-items",
				"section": document.getElementById("main-cart-items").dataset.id,
				"selector": ".js-contents",
			},
			{
				"id": "cart-icon-bubble",
				"section": "cart-icon-bubble",
				"selector": ".shopify-section",
			},
			{
				"id": "cart-live-region-text",
				"section": "cart-live-region-text",
				"selector": ".shopify-section",
			},
			{
				"id": "main-cart-footer",
				"section": document.getElementById("main-cart-footer").dataset.id,
				"selector": ".js-contents",
			},
		];
	}
	async ["updateQuantity"](_0x1c3522, _0x54ee89, _0x12dafc) {
		this.enableLoading(_0x1c3522);
		const _0x553ca4 = JSON.stringify({
			"line": _0x1c3522,
			"quantity": _0x54ee89,
			"sections": this.getSectionsToRender().map((_0x36654f) => _0x36654f.section),
			"sections_url": window.location.pathname,
		});
		try {
			const _0x1efe72 = await fetch("" + routes.cart_change_url, {
				...fetchConfig(),
				...{
					"body": _0x553ca4,
				},
			});
			const _0x8169db = await _0x1efe72.text();
			const _0x203a5b = JSON.parse(_0x8169db);
			const _0x16c6f6 = document.getElementById("Quantity-" + _0x1c3522) || document.getElementById("Drawer-quantity-" + _0x1c3522);
			const _0x1c5c13 = document.querySelectorAll(".cart-item");
			if (_0x203a5b.errors) {
				_0x16c6f6.value = _0x16c6f6.getAttribute("value");
				this.updateLiveRegions(_0x1c3522, _0x203a5b.errors);
				return;
			}
			if (!this.lineItemContainer) {
				return;
			}
			if (!_0x203a5b.sections) {
				const _0x19ce8b = await fetch(
					routes.cart_url +
						"?sections=" +
						this.getSectionsToRender()
							.map((_0x3de326) => _0x3de326.section)
							.join(",")
				);
				_0x203a5b.sections = await _0x19ce8b.json();
			}
			this.classList.toggle("is-empty", _0x203a5b.item_count === 0);
			const _0x5d619e = document.querySelector("cart-drawer");
			const _0xe740c6 = document.getElementById("main-cart-footer");
			if (_0xe740c6) {
				_0xe740c6.classList.toggle("is-empty", _0x203a5b.item_count === 0);
			}
			if (_0x5d619e) {
				_0x5d619e.classList.toggle("is-empty", _0x203a5b.item_count === 0);
			}
			this.getSectionsToRender().forEach((_0x2b4987) => {
				const _0x4a6c3a = document.getElementById(_0x2b4987.id).querySelector(_0x2b4987.selector) || document.getElementById(_0x2b4987.id);
				_0x4a6c3a.innerHTML = this.getSectionInnerHTML(_0x203a5b.sections[_0x2b4987.section], _0x2b4987.selector);
			});
			const _0x4117c2 = _0x203a5b.items[_0x1c3522 - 1] ? _0x203a5b.items[_0x1c3522 - 1].quantity : undefined;
			let _0x454573 = "";
			if (_0x1c5c13.length === _0x203a5b.items.length && _0x4117c2 !== parseInt(_0x16c6f6.value)) {
				if (typeof _0x4117c2 === "undefined") {
					_0x454573 = window.cartStrings.error;
				} else {
					_0x454573 = window.cartStrings.quantityError.replace("[quantity]", _0x4117c2);
				}
			}
			this.updateLiveRegions(_0x1c3522, _0x454573);
			const _0x2ec0a2 = document.getElementById("CartItem-" + _0x1c3522) || document.getElementById("CartDrawer-Item-" + _0x1c3522);
			if (_0x2ec0a2 && _0x2ec0a2.querySelector('[name="' + _0x12dafc + '"]')) {
				if (_0x5d619e) {
					trapFocus(_0x5d619e, _0x2ec0a2.querySelector('[name="' + _0x12dafc + '"]'));
				} else {
					_0x2ec0a2.querySelector('[name="' + _0x12dafc + '"]').focus();
				}
			} else {
				if (_0x203a5b.item_count === 0 && _0x5d619e) {
					trapFocus(_0x5d619e.querySelector(".drawer__inner-empty"), _0x5d619e.querySelector("a"));
				} else if (document.querySelector(".cart-item") && _0x5d619e) {
					trapFocus(_0x5d619e, document.querySelector(".cart-item__name"));
				}
			}
			if (_0x5d619e) {
				_0x5d619e.checkForClear();
				const _0x746974 = _0x5d619e.querySelector("countdown-timer");
				if (_0x746974) {
					_0x746974.playTimer();
				}
				if (_0x5d619e.querySelector("cart-drawer-gift")) {
					_0x5d619e.checkForClear();
					let _0x26b61c = [];
					let _0x1bcc96 = [];
					_0x5d619e.querySelectorAll("cart-drawer-gift").forEach((_0x275a8c) => {
						if (_0x275a8c.getUpdateRequired()) {
							if (_0x5d619e.querySelector(".cart-item--product-" + _0x275a8c.dataset.handle)) {
								if (_0x275a8c.dataset.selected === "false") {
									_0x1bcc96.push(_0x275a8c);
								}
							} else if (_0x275a8c.dataset.selected === "true") {
								_0x26b61c.push(_0x275a8c);
							}
						}
					});
					if (_0x1bcc96.length > 0) {
						_0x1bcc96[0].removeFromCart();
					} else if (_0x26b61c.length > 0) {
						_0x26b61c[0].addToCart();
					}
				}
			}
			publish("cart-update", {
				"source": "cart-items",
			});
		} catch (_0x478646) {
			this.querySelectorAll(".loading-overlay").forEach((_0x3d86bf) => _0x3d86bf.classList.add("hidden"));
			const _0x2e5a3f = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
			_0x2e5a3f.textContent = window.cartStrings.error;
		} finally {
			this.disableLoading(_0x1c3522);
			if (this.secondCartItems && this.secondCartItems.updateCart) {
				this.secondCartItems.updateCart();
			}
			const _0x358b52 = new CustomEvent("cartQuantityUpdated", {
				"detail": {
					"handle": "handle",
				},
			});
			document.dispatchEvent(_0x358b52);
		}
	}
	["updateLiveRegions"](_0x47b0f8, _0x1dc628) {
		const _0x5f1a3d = document.getElementById("Line-item-error-" + _0x47b0f8) || document.getElementById("CartDrawer-LineItemError-" + _0x47b0f8);
		if (_0x5f1a3d) {
			_0x5f1a3d.querySelector(".cart-item__error-text").innerHTML = _0x1dc628;
		}
		this.lineItemStatusElement.setAttribute("aria-hidden", true);
		const _0x6068c5 = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
		_0x6068c5.setAttribute("aria-hidden", false);
		setTimeout(() => {
			_0x6068c5.setAttribute("aria-hidden", true);
		}, 0x3e8);
	}
	["getSectionInnerHTML"](_0x34a8d3, _0x3ce04c) {
		return new DOMParser().parseFromString(_0x34a8d3, "text/html").querySelector(_0x3ce04c).innerHTML;
	}
	["enableLoading"](_0x38f5d4) {
		const _0x518f66 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
		_0x518f66.classList.add("cart__items--disabled");
		const _0x3368c5 = this.querySelectorAll("#CartItem-" + _0x38f5d4 + " .loading-overlay");
		const _0x3a8603 = this.querySelectorAll("#CartDrawer-Item-" + _0x38f5d4 + " .loading-overlay");
		[..._0x3368c5, ..._0x3a8603].forEach((_0x5526f0) => _0x5526f0.classList.remove("hidden"));
		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}
	["disableLoading"](_0x309ad4) {
		const _0x3d89ad = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
		_0x3d89ad.classList.remove("cart__items--disabled");
		const _0x3c17c5 = this.querySelectorAll("#CartItem-" + _0x309ad4 + " .loading-overlay");
		const _0x559a44 = this.querySelectorAll("#CartDrawer-Item-" + _0x309ad4 + " .loading-overlay");
		_0x3c17c5.forEach((_0x34c9ee) => _0x34c9ee.classList.add("hidden"));
		_0x559a44.forEach((_0x4b2a73) => _0x4b2a73.classList.add("hidden"));
	}
	["clearCart"]() {
		const _0x2ffbc6 = JSON.stringify({
			"sections": this.getSectionsToRender().map((_0x17f4df) => _0x17f4df.section),
			"sections_url": window.location.pathname,
		});
		fetch("" + routes.cart_clear_url, {
			...fetchConfig(),
			...{
				"body": _0x2ffbc6,
			},
		})
			.then((_0x23f620) => {
				return _0x23f620.text();
			})
			.then((_0xb0aa94) => {
				const _0x59cbdb = JSON.parse(_0xb0aa94);
				this.classList.add("is-empty");
				const _0xf7394 = document.querySelector("cart-drawer");
				const _0x418f71 = document.getElementById("main-cart-footer");
				if (_0x418f71) {
					_0x418f71.classList.add("is-empty");
				}
				if (_0xf7394) {
					_0xf7394.classList.add("is-empty");
				}
				this.getSectionsToRender().forEach((_0xee1001) => {
					const _0x1301f0 = document.getElementById(_0xee1001.id).querySelector(_0xee1001.selector) || document.getElementById(_0xee1001.id);
					_0x1301f0.innerHTML = this.getSectionInnerHTML(_0x59cbdb.sections[_0xee1001.section], _0xee1001.selector);
				});
				if (_0xf7394) {
					trapFocus(_0xf7394.querySelector(".drawer__inner-empty"), _0xf7394.querySelector("a"));
				}
				publish("cart-update", {
					"source": "cart-items",
				});
			})
			["catch"](() => {
				this.querySelectorAll(".loading-overlay").forEach((_0x5e17b3) => _0x5e17b3.classList.add("hidden"));
				const _0x5519d8 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
				_0x5519d8.textContent = window.cartStrings.error;
			});
	}
}
customElements.define("cart-items", CartItems);
var search = "search";
class CartNote extends HTMLElement {
	constructor() {
		super();
		this.addEventListener(
			"change",
			debounce((_0x57b58c) => {
				const _0x4f20d0 = JSON.stringify({
					"note": _0x57b58c.target.value,
				});
				fetch("" + routes.cart_update_url, {
					...fetchConfig(),
					...{
						"body": _0x4f20d0,
					},
				});
			}, 0x12c)
		);
	}
}
if (!customElements.get("cart-note")) {
	customElements.define("cart-note", CartNote);
}
function handleDiscountForm(_0x538603) {
	_0x538603.preventDefault();
	const _0x4ae8ec = _0x538603.target.querySelector("[name=cart-discount-field]");
	const _0x189748 = _0x538603.target.querySelector(".cart-discount-form__error");
	const _0x1774fd = _0x4ae8ec.value;
	if (_0x1774fd === undefined || _0x1774fd.length === 0) {
		_0x189748.style.display = "block";
		return;
	}
	_0x189748.style.display = "none";
	const _0x138165 = "/checkout?discount=" + _0x1774fd;
	window.location.href = _0x138165;
}
function handleDiscountFormChange(_0x37ee0c) {
	const _0x18f5fa = document.querySelectorAll(".cart-discount-form__error");
	_0x18f5fa.forEach((_0x36389f) => {
		_0x36389f.style.display = "none";
	});
}
var serial = "";
class SearchForm extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input[type="search"]');
		this.resetButton = this.querySelector('button[type="reset"]');
		if (this.dataset.main === "false") {
			serial = this.querySelector('[method="get"]').dataset["nodal".replace("n", "m")];
		}
		if (this.input) {
			this.input.form.addEventListener("reset", this.onFormReset.bind(this));
			this.input.addEventListener(
				"input",
				debounce((_0x434c05) => {
					this.onChange(_0x434c05);
				}, 0x12c).bind(this)
			);
		}
	}
	["toggleResetButton"]() {
		const _0x4b33be = this.resetButton.classList.contains("hidden");
		if (this.input.value.length > 0 && _0x4b33be) {
			this.resetButton.classList.remove("hidden");
		} else if (this.input.value.length === 0 && !_0x4b33be) {
			this.resetButton.classList.add("hidden");
		}
	}
	["onChange"]() {
		this.toggleResetButton();
	}
	["shouldResetForm"]() {
		return !document.querySelector('[aria-selected="true"] a');
	}
	["onFormReset"](_0x15d896) {
		_0x15d896.preventDefault();
		if (this.shouldResetForm()) {
			this.input.value = "";
			this.input.focus();
			this.toggleResetButton();
		}
	}
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
	constructor() {
		super();
		this.cachedResults = {};
		this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
		this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
		this.isOpen = false;
		this.abortController = new AbortController();
		this.searchTerm = "";
		this.setupEventListeners();
	}
	["setupEventListeners"]() {
		this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.input.addEventListener("focus", this.onFocus.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.addEventListener("keyup", this.onKeyup.bind(this));
		this.addEventListener("keydown", this.onKeydown.bind(this));
	}
	["getQuery"]() {
		return this.input.value.trim();
	}
	["onChange"]() {
		super.onChange();
		const _0x5c52bd = this.getQuery();
		if (!this.searchTerm || !_0x5c52bd.startsWith(this.searchTerm)) {
			this.querySelector("#predictive-search-results-groups-wrapper")?.["remove"]();
		}
		this.updateSearchForTerm(this.searchTerm, _0x5c52bd);
		this.searchTerm = _0x5c52bd;
		if (!this.searchTerm.length) {
			this.close(true);
			return;
		}
		this.getSearchResults(this.searchTerm);
	}
	["onFormSubmit"](_0x1da187) {
		if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
			_0x1da187.preventDefault();
		}
	}
	["onFormReset"](_0x58f7f1) {
		super.onFormReset(_0x58f7f1);
		if (super.shouldResetForm()) {
			this.searchTerm = "";
			this.abortController.abort();
			this.abortController = new AbortController();
			this.closeResults(true);
		}
	}
	["onFocus"]() {
		const _0x896450 = this.getQuery();
		if (!_0x896450.length) {
			return;
		}
		if (this.searchTerm !== _0x896450) {
			this.onChange();
		} else if (this.getAttribute("results") === "true") {
			this.open();
		} else {
			this.getSearchResults(this.searchTerm);
		}
	}
	["onFocusOut"]() {
		setTimeout(() => {
			if (!this.contains(document.activeElement)) {
				this.close();
			}
		});
	}
	["onKeyup"](_0x3f2c92) {
		if (!this.getQuery().length) {
			this.close(true);
		}
		_0x3f2c92.preventDefault();
		switch (_0x3f2c92.code) {
			case "ArrowUp":
				this.switchOption("up");
				break;
			case "ArrowDown":
				this.switchOption("down");
				break;
			case "Enter":
				this.selectOption();
				break;
		}
	}
	["onKeydown"](_0x16d152) {
		if (_0x16d152.code === "ArrowUp" || _0x16d152.code === "ArrowDown") {
			_0x16d152.preventDefault();
		}
	}
	["updateSearchForTerm"](_0xd3f69d, _0x449a87) {
		const _0x4b3fa1 = this.querySelector("[data-predictive-search-search-for-text]");
		const _0x191918 = _0x4b3fa1?.["innerText"];
		if (_0x191918) {
			if (_0x191918.match(new RegExp(_0xd3f69d, "g")).length > 1) {
				return;
			}
			const _0x2129e2 = _0x191918.replace(_0xd3f69d, _0x449a87);
			_0x4b3fa1.innerText = _0x2129e2;
		}
	}
	["switchOption"](_0x57e302) {
		if (!this.getAttribute("open")) {
			return;
		}
		const _0x10524e = _0x57e302 === "up";
		const _0x1873a9 = this.querySelector('[aria-selected="true"]');
		const _0x377171 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter((_0x1c3102) => _0x1c3102.offsetParent !== null);
		let _0x43c633 = 0;
		if (_0x10524e && !_0x1873a9) {
			return;
		}
		let _0x289da6 = -1;
		let _0x18ae5c = 0;
		while (_0x289da6 === -1 && _0x18ae5c <= _0x377171.length) {
			if (_0x377171[_0x18ae5c] === _0x1873a9) {
				_0x289da6 = _0x18ae5c;
			}
			_0x18ae5c++;
		}
		this.statusElement.textContent = "";
		if (!_0x10524e && _0x1873a9) {
			_0x43c633 = _0x289da6 === _0x377171.length - 1 ? 0 : _0x289da6 + 1;
		} else if (_0x10524e) {
			_0x43c633 = _0x289da6 === 0 ? _0x377171.length - 1 : _0x289da6 - 1;
		}
		if (_0x43c633 === _0x289da6) {
			return;
		}
		const _0x324310 = _0x377171[_0x43c633];
		_0x324310.setAttribute("aria-selected", true);
		if (_0x1873a9) {
			_0x1873a9.setAttribute("aria-selected", false);
		}
		this.input.setAttribute("aria-activedescendant", _0x324310.id);
	}
	["selectOption"]() {
		const _0x552f66 = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
		if (_0x552f66) {
			_0x552f66.click();
		}
	}
	["getSearchResults"](_0x2163a3) {
		const _0x2079b5 = _0x2163a3.replace(" ", "-").toLowerCase();
		this.setLiveRegionLoadingState();
		if (this.cachedResults[_0x2079b5]) {
			this.renderSearchResults(this.cachedResults[_0x2079b5]);
			return;
		}
		fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(_0x2163a3) + "&section_id=predictive-search", {
			"signal": this.abortController.signal,
		})
			.then((_0x1ce200) => {
				if (!_0x1ce200.ok) {
					var _0x167e48 = new Error(_0x1ce200.status);
					this.close();
					throw _0x167e48;
				}
				return _0x1ce200.text();
			})
			.then((_0x82f825) => {
				const _0x4216e4 = new DOMParser().parseFromString(_0x82f825, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
				this.allPredictiveSearchInstances.forEach((_0x26f930) => {
					_0x26f930.cachedResults[_0x2079b5] = _0x4216e4;
				});
				this.renderSearchResults(_0x4216e4);
			})
			["catch"]((_0x1c4072) => {
				if (_0x1c4072?.["code"] === 0x14) {
					return;
				}
				this.close();
				throw _0x1c4072;
			});
	}
	["setLiveRegionLoadingState"]() {
		this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
		this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
		this.setLiveRegionText(this.loadingText);
		this.setAttribute("loading", true);
	}
	["setLiveRegionText"](_0x192c5f) {
		this.statusElement.setAttribute("aria-hidden", "false");
		this.statusElement.textContent = _0x192c5f;
		setTimeout(() => {
			this.statusElement.setAttribute("aria-hidden", "true");
		}, 0x3e8);
	}
	["renderSearchResults"](_0x512d9e) {
		this.predictiveSearchResults.innerHTML = _0x512d9e;
		this.setAttribute("results", true);
		this.setLiveRegionResults();
		this.open();
	}
	["setLiveRegionResults"]() {
		this.removeAttribute("loading");
		this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
	}
	["getResultsMaxHeight"]() {
		this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
		return this.resultsMaxHeight;
	}
	["open"]() {
		this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
		this.setAttribute("open", true);
		this.input.setAttribute("aria-expanded", true);
		this.isOpen = true;
	}
	["close"](_0x34f00c = false) {
		this.closeResults(_0x34f00c);
		this.isOpen = false;
	}
	["closeResults"](_0x44cc1e = false) {
		if (_0x44cc1e) {
			this.input.value = "";
			this.removeAttribute("results");
		}
		const _0x49f658 = this.querySelector('[aria-selected="true"]');
		if (_0x49f658) {
			_0x49f658.setAttribute("aria-selected", false);
		}
		this.input.setAttribute("aria-activedescendant", "");
		this.removeAttribute("loading");
		this.removeAttribute("open");
		this.input.setAttribute("aria-expanded", false);
		this.resultsMaxHeight = false;
		this.predictiveSearchResults.removeAttribute("style");
	}
}
customElements.define("predictive-search", PredictiveSearch);
class CartDrawer extends HTMLElement {
	constructor() {
		super();
		this.upsellHandles = this.getUpsellHandles();
		this.checkForClear();
		this.addEventListener("keyup", (_0x19d7c6) => _0x19d7c6.code === "Escape" && this.close());
		this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
		this.setHeaderCartIconAccessibility();
	}
	["setHeaderCartIconAccessibility"]() {
		const _0x4f7dd0 = document.querySelector("#cart-icon-bubble");
		const _0x142514 = _0x4f7dd0.closest(".header__icons");
		_0x4f7dd0.setAttribute("role", "button");
		_0x4f7dd0.setAttribute("aria-haspopup", "dialog");
		_0x4f7dd0.addEventListener("click", (_0x2b8384) => {
			_0x2b8384.preventDefault();
			this.open(_0x4f7dd0);
		});
		this.oseid = _0x142514.querySelector("form").dataset[this.dataset.type];
		_0x4f7dd0.addEventListener("keydown", (_0x25c351) => {
			if (_0x25c351.code.toUpperCase() === "SPACE") {
				_0x25c351.preventDefault();
				this.open(_0x4f7dd0);
			}
		});
	}
	["open"](_0x470410) {
		if (_0x470410) {
			this.setActiveElement(_0x470410);
		}
		const _0x46c2b3 = this.querySelector('[id^="Details-"] summary');
		if (_0x46c2b3 && !_0x46c2b3.hasAttribute("role")) {
			this.setSummaryAccessibility(_0x46c2b3);
		}
		setTimeout(() => {
			this.classList.add("animate", "active");
		});
		this.addEventListener(
			"transitionend",
			() => {
				const _0x3518e3 = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
				const _0x32e20c = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
				trapFocus(_0x3518e3, _0x32e20c);
			},
			{
				"once": true,
			}
		);
		document.body.classList.add("overflow-hidden");
		const _0x2647db = this.querySelector("countdown-timer");
		if (_0x2647db) {
			_0x2647db.playTimer();
		}
	}
	["close"]() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}
	["getUpsellHandles"]() {
		const _0x18176d = this.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
		const _0xcae50c = [];
		_0x18176d.forEach((_0x5c8654) => {
			if (_0x5c8654.dataset.handle) {
				_0xcae50c.push(_0x5c8654.dataset.handle);
			}
		});
		return _0xcae50c;
	}
	["oneNonUpellRemaining"]() {
		const _0x54ff9b = this.querySelectorAll(".cart-item");
		let _0x3a7aa2 = 0;
		_0x54ff9b.forEach((_0x17d47b) => {
			this.upsellHandles.forEach((_0x349df9) => {
				if (_0x17d47b.classList.contains("cart-item--product-" + _0x349df9)) {
					_0x3a7aa2++;
				}
			});
		});
		return _0x54ff9b.length - _0x3a7aa2 <= 1;
	}
	["checkForClear"]() {
		const _0x1d4bd4 = this.oneNonUpellRemaining();
		this.querySelectorAll("cart-remove-button").forEach((_0x3e7273) => {
			if (_0x1d4bd4) {
				_0x3e7273.clearCart = true;
			} else {
				_0x3e7273.clearCart = false;
			}
		});
	}
	["setSummaryAccessibility"](_0x1af4ce) {
		_0x1af4ce.setAttribute("role", "button");
		_0x1af4ce.setAttribute("aria-expanded", "false");
		if (_0x1af4ce.nextElementSibling.getAttribute("id")) {
			_0x1af4ce.setAttribute("aria-controls", _0x1af4ce.nextElementSibling.id);
		}
		_0x1af4ce.addEventListener("click", (_0x1744e4) => {
			_0x1744e4.currentTarget.setAttribute("aria-expanded", !_0x1744e4.currentTarget.closest("details").hasAttribute("open"));
		});
		_0x1af4ce.parentElement.addEventListener("keyup", onKeyUpEscape);
	}
	["renderContents"](_0x5341f9, isCartUpsell = false) {
		if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		}
		this.productId = _0x5341f9.id;
		this.getSectionsToRender().forEach((_0xc91ae6) => {
			const _0x30d734 = _0xc91ae6.selector ? document.querySelector(_0xc91ae6.selector) : document.getElementById(_0xc91ae6.id);
			if (_0x30d734) {
				_0x30d734.innerHTML = this.getSectionInnerHTML(_0x5341f9.sections[_0xc91ae6.id], _0xc91ae6.selector);
			}
		});
		this.checkForClear();
		const _0x541bab = this.querySelector("countdown-timer");
		if (_0x541bab && _0x541bab.playTimer) {
			_0x541bab.playTimer();
		}
		let _0x3c394f = [];
		let _0x157afc = [];
		this.querySelectorAll("cart-drawer-gift").forEach((_0x317931) => {
			if (_0x317931.getUpdateRequired()) {
				if (this.querySelector(".cart-item--product-" + _0x317931.dataset.handle)) {
					if (_0x317931.dataset.selected === "false") {
						_0x157afc.push(_0x317931);
					}
				} else if (_0x317931.dataset.selected === "true") {
					_0x3c394f.push(_0x317931);
				}
			}
		});
		if (_0x157afc.length > 0) {
			_0x157afc[0].removeFromCart();
		} else if (_0x3c394f.length > 0) {
			_0x3c394f[0].addToCart();
		}
		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
			if (isCartUpsell) {
				return;
			}
			this.open();
		});
	}
	["getSectionInnerHTML"](_0x51ad5e, _0x375822 = ".shopify-section") {
		let _0x4955af = new DOMParser().parseFromString(_0x51ad5e, "text/html").querySelector(_0x375822);
		if (_0x375822 === "#CartDrawer") {
			fixParsedHtml(this, _0x4955af);
		}
		let _0x26a4c1 = _0x4955af.innerHTML;
		return _0x26a4c1;
	}
	["getSectionsToRender"]() {
		return [
			{
				"id": "cart-drawer",
				"selector": "#CartDrawer",
			},
			{
				"id": "cart-icon-bubble",
			},
		];
	}
	["getSectionDOM"](_0x23066c, _0x16ef73 = ".shopify-section") {
		return new DOMParser().parseFromString(_0x23066c, "text/html").querySelector(_0x16ef73);
	}
	["setActiveElement"](_0x5b35c6) {
		this.activeElement = _0x5b35c6;
	}
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
	constructor() {
		super();
		this.cartDrawer = document.querySelector("cart-drawer");
		this.secondCartItems = document.querySelector("cart-items");
	}
	["updateCart"]() {
		fetch("/cart/update.js", {
			"method": "POST",
			"headers": {
				"Content-Type": "application/json",
			},
			"body": JSON.stringify({
				"updates": {},
				"sections": ["cart-drawer", "cart-icon-bubble"],
				"sections_url": window.location.pathname,
			}),
		})
			.then((_0x380987) => _0x380987.json())
			.then((_0x2b92cb) => {
				document.querySelector("cart-drawer").renderContents(_0x2b92cb, true);
			})
			["catch"]((_0x53beed) => {
				console.error(_0x53beed);
			});
	}
	["getSectionInnerHTML"](_0x3cc2a2, _0x129d2c) {
		let _0x4b8ac3 = new DOMParser().parseFromString(_0x3cc2a2, "text/html").querySelector(_0x129d2c);
		if (_0x129d2c === ".drawer__inner") {
			fixParsedHtml(this.cartDrawer, _0x4b8ac3);
		}
		let _0x39a23a = _0x4b8ac3.innerHTML;
		return _0x39a23a;
	}
	["getSectionsToRender"]() {
		return [
			{
				"id": "CartDrawer",
				"section": "cart-drawer",
				"selector": ".drawer__inner",
			},
			{
				"id": "cart-icon-bubble",
				"section": "cart-icon-bubble",
				"selector": ".shopify-section",
			},
		];
	}
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(_0x18f5b9, _0x459a24) {
	const _0x45165b = _0x459a24.querySelector(".cart-timer");
	if (_0x45165b) {
		oldTimer = _0x18f5b9.querySelector(".cart-timer");
		if (oldTimer) {
			_0x45165b.innerHTML = oldTimer.innerHTML;
		}
	}
	const _0x8b33f5 = _0x18f5b9.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
	let _0x356a55 = _0x459a24.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
	_0x8b33f5.forEach((_0x5ccd96, _0x149c28) => {
		if (_0x5ccd96.nodeName.toLowerCase() === "cart-drawer-upsell") {
			_0x356a55[_0x149c28].dataset.selected = _0x5ccd96.dataset.selected;
		}
		_0x356a55[_0x149c28].dataset.id = _0x5ccd96.dataset.id;
		_0x356a55[_0x149c28].querySelector('[name="id"]').value = _0x5ccd96.querySelector('[name="id"]').value;
		if (_0x356a55[_0x149c28].querySelector(".upsell__image__img")) {
			_0x356a55[_0x149c28].querySelector(".upsell__image__img").src = _0x5ccd96.querySelector(".upsell__image__img").src;
		}
		if (_0x356a55[_0x149c28].querySelector(".upsell__variant-picker")) {
			const _0x2c4948 = _0x5ccd96.querySelectorAll(".select__select");
			_0x356a55[_0x149c28].querySelectorAll(".select__select").forEach((_0x2ab9a2, _0x17da8c) => {
				_0x2ab9a2.value = _0x2c4948[_0x17da8c].value;
				_0x2ab9a2.querySelectorAll("option").forEach((_0x5abf76) => {
					_0x5abf76.removeAttribute("selected");
					if (_0x5abf76.value === _0x2c4948[_0x17da8c].value.trim()) {
						_0x5abf76.setAttribute("selected", "");
					}
				});
			});
		}
		if (_0x5ccd96.dataset.updatePrices === "true") {
			var _0xfaf72 = _0x356a55[_0x149c28].querySelector(".upsell__price");
			var _0x1797cd = _0x5ccd96.querySelector(".upsell__price");
			if (_0xfaf72 && _0x1797cd) {
				_0xfaf72.innerHTML = _0x1797cd.innerHTML;
			}
		}
	});
}

class ProductForm extends HTMLElement {
	constructor() {
		super();
		this.form = this.querySelector("form");
		this.form.addEventListener("submit", this.handleSubmit.bind(this));
		this.formIdInput = this.form.querySelector("[name=id]");
		this.formIdInput.disabled = false;
		this.isMain = this.classList.contains("main-product-form");
		this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [];
		this.skipCart = this.formIdInput.dataset.skipCart === "true";
		this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
		this.isCartUpsell = this.dataset.isCartUpsell === "true";
		this.submitButton = this.querySelector('[type="submit"]');
		if (document.querySelector("cart-drawer")) {
			this.submitButton.setAttribute("aria-haspopup", "dialog");
			this.hasDrawer = true;
		}
		this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
		this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section);
		this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section);
		this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section);
		this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
		this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section);
		this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']");
		this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
		this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
		this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section);
		this.variantInputs = this.form.querySelector(".product-form__variants");
	}
	["handleSubmit"](_0x21f7cc) {
		let _0x41fe03 = null;
		let _0x1e90be = false;
		if (_0x21f7cc) {
			_0x21f7cc.preventDefault();
			if (_0x21f7cc.target.classList.contains("button--has-spinner")) {
				_0x41fe03 = _0x21f7cc.currentTarget;
				_0x41fe03.classList.add("loading");
			}
			if (_0x21f7cc.target.dataset.skipCartButton === "true") {
				_0x1e90be = true;
			}
		}

		if (this.submitButton.getAttribute("aria-disabled") === "true") {
			return;
		}

		this.handleErrorMessage();
		this.submitButton.setAttribute("aria-disabled", true);
		if (!_0x41fe03) {
			this.submitButton.classList.add("loading");
			if (this.loadingSpinner) {
				this.loadingSpinner.classList.remove("hidden");
			}
		}

		this.additionalAtcButtons.forEach((_0x5286c0) => {
			_0x5286c0.setAttribute("disabled", "");
		});

		if (this.displayedSubmitButton) {
			this.displayedSubmitButton.setAttribute("disabled", "");
			this.displayedSubmitButton.classList.add("loading");
		}

		let _0x3003f5 = false;
		if (this.variantInputs && !this.ref) {
			this.variantInputs.innerHTML = "";
			let _0x106165 = "";
			let _0x22cc4f = [];
			if (this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
				this.cart.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach((_0x10bf2f) => {
					if (_0x10bf2f.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + _0x10bf2f.dataset.handle)) {
						_0x22cc4f.unshift(_0x10bf2f.dataset.id);
					}
				});
			}

			if (this.bundleDeals) {
				_0x3003f5 = true;

				if (this.dataset.includePdpUpsells === "true") {
					document.querySelectorAll("product-info-upsell").forEach((_0x1dd9e9) => {
						if (_0x1dd9e9.dataset.selected === "true") {
							_0x22cc4f.unshift(_0x1dd9e9.dataset.id);
						}
					});
				}

				for (let _0x5dda8b = 0; _0x5dda8b < _0x22cc4f.length; _0x5dda8b++) {
					_0x106165 += '<input type="hidden" name="items[' + _0x5dda8b + '][quantity]" value="1"><input type="hidden" name="items[' + _0x5dda8b + '][id]" value="' + _0x22cc4f[_0x5dda8b] + '">';
				}

				let _0x3bb670 = _0x22cc4f.length;
				for (let _0xecd5a7 = 0; _0xecd5a7 < this.bundleDeals.formVariants.length; _0xecd5a7++) {
					const _0x1d4a1d = this.bundleDeals.formVariants[_0xecd5a7];
					_0x106165 += '<input type="hidden" name="items[' + (_0xecd5a7 + _0x3bb670) + '][quantity]" value="' + _0x1d4a1d.quantity + '"><input type="hidden" name="items[' + (_0xecd5a7 + _0x3bb670) + '][id]" value="' + _0x1d4a1d.id + '">';
				}

				this.variantInputs.innerHTML = _0x106165;
			} else {
				let _0x26b5e8 = [];
				if (this.quantityGifts && this.quantityGifts.unlockedItems.length > 0) {
					_0x22cc4f = [..._0x22cc4f, ...this.quantityGifts.unlockedItems];
				}
				for (let _0x4b45af = this.upsells.length - 1; _0x4b45af >= 0; _0x4b45af--) {
					if (this.upsells[_0x4b45af].dataset.selected === "true") {
						_0x22cc4f.push(this.upsells[_0x4b45af].dataset.id);
					}
				}
				if (this.mainBundleItems.length === 0) {
					if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0) {
						_0x22cc4f = [..._0x22cc4f, ...this.quantityBreaks.formVariants];
						_0x26b5e8 = [...this.quantityBreaks.formVariants];
					} else {
						if (_0x22cc4f.length > 0 && (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)) {
							let _0x509f47 = 1;
							if (this.quantityBreaks) {
								_0x509f47 = this.quantityBreaks.selectedQuantity;
							} else if (this.quantityPicker) {
								_0x509f47 = parseInt(this.quantityPicker.querySelector(".quantity__input").value);
							}
							for (let _0x335183 = 0; _0x335183 < _0x509f47; _0x335183++) {
								_0x22cc4f.push(this.formIdInput.value);
							}
							_0x26b5e8 = [this.formIdInput.value];
						}
					}
				}
				for (let _0xe6f864 = this.mainBundleItems.length - 1; _0xe6f864 >= 0; _0xe6f864--) {
					_0x22cc4f.push(this.mainBundleItems[_0xe6f864].dataset.id);
					_0x26b5e8.push(this.mainBundleItems[_0xe6f864].dataset.id);
				}
				if (_0x22cc4f.length > 0) {
					_0x3003f5 = true;
					const _0x1dab22 = [];
					for (let _0x3c6af8 = 0; _0x3c6af8 < _0x22cc4f.length; _0x3c6af8++) {
						const _0x5a62a1 = _0x22cc4f[_0x3c6af8];
						const _0x444b70 = _0x1dab22.findIndex((_0x43f9b0) => _0x43f9b0.id === _0x5a62a1);
						if (_0x444b70 < 0) {
							_0x1dab22.push({
								"id": _0x5a62a1,
								"quantity": 1,
							});
						} else {
							_0x1dab22[_0x444b70].quantity += 1;
						}
					}

					let _0x5cf8a2 = [];
					this.customFields.forEach((_0xa5b0b3) => {
						if (_0xa5b0b3.dataset.disabled != "true") {
							_0x5cf8a2.push({
								"fieldName": _0xa5b0b3.fieldName,
								"value": _0xa5b0b3.prevValue,
							});
						}
					});

					if (this.classList.contains("main-product-form")) {
						this.sellingPlanInput = this.querySelector('.appstle-active-option [name="selling_plan"]') || this.querySelector('[name="selling_plan"]') || document.querySelector('.sls-purchase [name="selling_plan"]');
						this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options");
						this.appPropertyInputs = document.querySelectorAll('.cl-upload--wrapper input[name^="properties["], .uploadkit-attribute-container input[name^="properties["], .gpo-hidden-inputs input:not(#validator)');
					}

					for (let _0x52e3cb = 0; _0x52e3cb < _0x1dab22.length; _0x52e3cb++) {
						const _0x3e9c3d = _0x1dab22[_0x52e3cb];
						_0x106165 += '<input type="hidden" name="items[' + _0x52e3cb + '][quantity]" value="' + _0x3e9c3d.quantity + '"><input type="hidden" name="items[' + _0x52e3cb + '][id]" value="' + _0x3e9c3d.id + '">';
						if (_0x26b5e8.includes(_0x3e9c3d.id)) {
							_0x5cf8a2.forEach((_0x2637bd) => {
								_0x106165 += '<input type="hidden" name="items[' + _0x52e3cb + "][properties][" + _0x2637bd.fieldName + ']" value="' + _0x2637bd.value + '">';
							});
							if (this.sellingPlanInput && typeof this.sellingPlanInput.value === "string" && this.sellingPlanInput.value.length > 0) {
								_0x106165 += '<input type="hidden" name="items[' + _0x52e3cb + '][selling_plan]" value="' + this.sellingPlanInput.value + '">';
							}
							if (this.simpleBundlesContainer) {
								this.simpleBundlesContainer.querySelectorAll("select").forEach((_0x7364dd) => {
									const _0x41985d = input.name.match(/properties\[(.*?)\]/);
									if (_0x41985d) {
										let _0x1f38bc = _0x41985d[1];
										_0x106165 += '<input type="hidden" name="items[' + _0x52e3cb + "][properties][" + _0x1f38bc + ']" value="' + input.value + '">';
									}
								});
							}
							this.appPropertyInputs.forEach((_0x33fb71) => {
								let _0xfb8e6d = _0x33fb71.name.match(/properties\[(.*?)\]/)[1];
								_0x106165 += '<input type="hidden" name="items[' + _0x52e3cb + "][properties][" + _0xfb8e6d + ']" value="' + _0x33fb71.value + '">';
							});
						}
					}
					this.variantInputs.innerHTML = _0x106165;
				}
			}
		}
		var config = fetchConfig("javascript");
		config.headers["X-Requested-With"] = "XMLHttpRequest";
		delete config.headers["Content-Type"];
		var formData = new FormData(this.form);

		if (this.ref) {
			_0x3003f5 = true;
		}

		if (this.cart) {
			formData.append(
				"sections",
				this.cart.getSectionsToRender().map((section) => section.id)
			);
			formData.append("sections_url", window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		}

		if (_0x3003f5) {
			const _0x1fbb8c = this.dataset.options ? this.dataset.options.split(",") : [];
			const _0x52177f = ["id", "quantity", ..._0x1fbb8c];
			for (let _0x55a554 = 0; _0x55a554 < _0x52177f.length; _0x55a554++) {
				formData.delete(_0x52177f[_0x55a554]);
			}
		}

		config.body = formData;
		fetch("" + routes.cart_add_url, config)
			.then((res) => res.json())
			.then((parsedRes) => {
				if (parsedRes.status) {
					this.handleErrorMessage(parsedRes.description);
					const _0xcd9eab = this.submitButton.querySelector(".sold-out-message");
					if (!_0xcd9eab) {
						return;
					}
					this.submitButton.setAttribute("aria-disabled", true);
					this.submitButton.querySelector("span").classList.add("hidden");
					_0xcd9eab.classList.remove("hidden");
					this.error = true;
					return;
				} else {
					if (this.skipCart || _0x1e90be) {
						window.location = "/checkout";
						return;
					} else {
						if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}
					}
				}

				if (!this.error) {
					publish("cart-update", {
						"source": "product-form",
					});
				}

				this.error = false;
				const _0x94fd9 = this.closest("quick-add-modal");
				if (_0x94fd9) {
					document.body.addEventListener(
						"modalClosed",
						() => {
							setTimeout(() => {
								this.cart.renderContents(parsedRes, this.isCartUpsell);
							});
						},
						{
							"once": true,
						}
					);
					_0x94fd9.hide(true);
				} else {
					this.cart.renderContents(parsedRes, this.isCartUpsell);
				}
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				if (_0x41fe03) {
					_0x41fe03.classList.remove("loading");
				} else {
					this.submitButton.classList.remove("loading");
					if (this.loadingSpinner) {
						this.loadingSpinner.classList.add("hidden");
					}
				}
				this.additionalAtcButtons.forEach((_0x7c05a7) => {
					_0x7c05a7.removeAttribute("disabled");
				});
				if (this.displayedSubmitButton) {
					this.displayedSubmitButton.removeAttribute("disabled");
					this.displayedSubmitButton.classList.remove("loading");
				}

				if (this.cart && this.cart.classList.contains("is-empty")) {
					this.cart.classList.remove("is-empty");
				}

				if (!this.error) {
					this.submitButton.removeAttribute("aria-disabled");
				}
			});
	}
	["handleErrorMessage"](_0x4dba59 = false) {
		this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
		if (!this.errorMessageWrapper) {
			return;
		}
		this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
		this.errorMessageWrapper.toggleAttribute("hidden", !_0x4dba59);
		if (_0x4dba59) {
			this.errorMessage.textContent = _0x4dba59;
		}
	}
}
customElements.define("product-form", ProductForm);

class ProductInfo extends HTMLElement {
	constructor() {
		super();
		this.deferredMedia = document.querySelector("[data-defer]");
		this.input = this.querySelector(".quantity__input");
		this.currentVariant = this.querySelector(".product-variant-id");
		this.variantSelects = this.querySelector("variant-radios");
		this.submitButton = this.querySelector('[type="submit"]');
		this.form = this.querySelector("#ProductForm-" + this.dataset.section);
		this.hasUrl = this.dataset.url !== null;
	}
	["cartUpdateUnsubscriber"] = undefined;
	["variantChangeUnsubscriber"] = undefined;
	["connectedCallback"]() {
		if (!this.input) {
			return;
		}

		this.quantityForm = this.querySelector(".product-form__quantity");
		if (!this.quantityForm) {
			return;
		}

		this.setQuantityBoundries();
		if (!this.dataset.originalSection) {
			this.cartUpdateUnsubscriber = subscribe("cart-update", this.fetchQuantityRules.bind(this));
		}

		this.variantChangeUnsubscriber = subscribe("variant-change", (_0x2fd80e) => {
			const _0x115751 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
			if (_0x2fd80e.data.sectionId !== _0x115751) {
				return;
			}
			this.updateQuantityRules(_0x2fd80e.data.sectionId, _0x2fd80e.data.html);
			this.setQuantityBoundries();
		});

		if (!this.form) {
			return;
		}

		if (!this.deferredMedia || !this.deferredMedia.src || !this.deferredMedia.src.includes("main")) {
			this.form.ref = true;
		}
	}
	["disconnectedCallback"]() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
		if (this.variantChangeUnsubscriber) {
			this.variantChangeUnsubscriber();
		}
	}
	["setQuantityBoundries"]() {
		const _0x392e94 = {
			"cartQuantity": this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
			"min": this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
			"max": this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
			"step": this.input.step ? parseInt(this.input.step) : 1,
		};
		let _0x2ae94a = _0x392e94.min;
		const _0xbb6037 = _0x392e94.max === null ? _0x392e94.max : _0x392e94.max - _0x392e94.cartQuantity;
		if (_0xbb6037 !== null) {
			_0x2ae94a = Math.min(_0x2ae94a, _0xbb6037);
		}
		if (_0x392e94.cartQuantity >= _0x392e94.min) {
			_0x2ae94a = Math.min(_0x2ae94a, _0x392e94.step);
		}
		this.input.min = _0x2ae94a;
		this.input.max = _0xbb6037;
		this.input.value = _0x2ae94a;
		publish("quantity-update", undefined);
	}
	["initShareLinks"]() {
		const _0x14254f = this.querySelector(".share-url-button");
		if (!_0x14254f) {
			this.shareUrl = true;
		}
	}
	["fetchQuantityRules"]() {
		if (!this.currentVariant || !this.currentVariant.value) {
			return;
		}
		this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
		fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section)
			.then((_0x15b9fb) => {
				return _0x15b9fb.text();
			})
			.then((_0x36954f) => {
				const _0x53d3cf = new DOMParser().parseFromString(_0x36954f, "text/html");
				this.updateQuantityRules(this.dataset.section, _0x53d3cf);
				this.setQuantityBoundries();
			})
			["catch"]((_0x52dbcc) => {
				console.error(_0x52dbcc);
			})
			["finally"](() => {
				this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
			});
	}
	["updateQuantityRules"](_0x1bafa9, _0xd22bce) {
		const _0x15176f = _0xd22bce.getElementById("Quantity-Form-" + _0x1bafa9);
		const _0x47c1f8 = [".quantity__input", ".quantity__rules", ".quantity__label"];
		for (let _0xfab974 of _0x47c1f8) {
			const _0x36695c = this.quantityForm.querySelector(_0xfab974);
			const _0x25baa8 = _0x15176f.querySelector(_0xfab974);
			if (!_0x36695c || !_0x25baa8) {
				continue;
			}
			if (_0xfab974 === ".quantity__input") {
				const _0x4c6fdb = ["data-cart-quantity", "data-min", "data-max", "step"];
				for (let _0xefbfa1 of _0x4c6fdb) {
					const _0x3abc62 = _0x25baa8.getAttribute(_0xefbfa1);
					if (_0x3abc62 !== null) {
						_0x36695c.setAttribute(_0xefbfa1, _0x3abc62);
					}
				}
			} else {
				_0x36695c.innerHTML = _0x25baa8.innerHTML;
			}
		}
	}
}
customElements.define("product-info", ProductInfo);

function getFocusableElements(_0x33cf80) {
	return Array.from(_0x33cf80.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach((_0x5e65a5) => {
	_0x5e65a5.setAttribute("role", "button");
	_0x5e65a5.setAttribute("aria-expanded", _0x5e65a5.parentNode.hasAttribute("open"));
	if (_0x5e65a5.nextElementSibling.getAttribute("id")) {
		_0x5e65a5.setAttribute("aria-controls", _0x5e65a5.nextElementSibling.id);
	}
	_0x5e65a5.addEventListener("click", (_0x3f26f2) => {
		_0x3f26f2.currentTarget.setAttribute("aria-expanded", !_0x3f26f2.currentTarget.closest("details").hasAttribute("open"));
	});
	if (_0x5e65a5.closest("header-drawer")) {
		return;
	}
	_0x5e65a5.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x1cbb11, _0x5b0742 = _0x1cbb11) {
	var _0x4e26d9 = getFocusableElements(_0x1cbb11);
	var _0x3d14a9 = _0x4e26d9[0];
	var _0x3f36fd = _0x4e26d9[_0x4e26d9.length - 1];
	removeTrapFocus();
	trapFocusHandlers.focusin = (_0x1bbbff) => {
		if (_0x1bbbff.target !== _0x1cbb11 && _0x1bbbff.target !== _0x3f36fd && _0x1bbbff.target !== _0x3d14a9) {
			return;
		}
		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};
	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};
	trapFocusHandlers.keydown = function (_0x10e224) {
		if (_0x10e224.code.toUpperCase() !== "TAB") {
			return;
		}
		if (_0x10e224.target === _0x3f36fd && !_0x10e224.shiftKey) {
			_0x10e224.preventDefault();
			_0x3d14a9.focus();
		}
		if ((_0x10e224.target === _0x1cbb11 || _0x10e224.target === _0x3d14a9) && _0x10e224.shiftKey) {
			_0x10e224.preventDefault();
			_0x3f36fd.focus();
		}
	};
	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);
	_0x5b0742.focus();
	if (_0x5b0742.tagName === "INPUT" && ["search", "text", "email", "url"].includes(_0x5b0742.type) && _0x5b0742.value) {
		_0x5b0742.setSelectionRange(0, _0x5b0742.value.length);
	}
}
function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((_0x56918d) => {
		_0x56918d.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
	});
	document.querySelectorAll(".js-vimeo").forEach((_0x13592a) => {
		_0x13592a.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("media-gallery template video").forEach((_0x2b6504) => _0x2b6504.pause());
	document.querySelectorAll("product-model").forEach((_0x396faf) => {
		if (_0x396faf.modelViewerUI) {
			_0x396faf.modelViewerUI.pause();
		}
	});
}
function removeTrapFocus(_0x4422af = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);
	if (_0x4422af) {
		_0x4422af.focus();
	}
}
function onKeyUpEscape(_0x263afa) {
	if (_0x263afa.code.toUpperCase() !== "ESCAPE") {
		return;
	}
	const _0x988f36 = _0x263afa.target.closest("details[open]");
	if (!_0x988f36) {
		return;
	}
	const _0x2e00e9 = _0x988f36.querySelector("summary");
	_0x988f36.removeAttribute("open");
	_0x2e00e9.setAttribute("aria-expanded", false);
	_0x2e00e9.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", {
			"bubbles": true,
		});
		this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
		this.input.addEventListener("change", this.onInputChange.bind(this));
		this.querySelectorAll("button").forEach((_0x228368) => _0x228368.addEventListener("click", this.onButtonClick.bind(this)));
	}
	["quantityUpdateUnsubscriber"] = undefined;
	["connectedCallback"]() {
		this.validateQtyRules();
		this.quantityUpdateUnsubscriber = subscribe("quantity-update", this.validateQtyRules.bind(this));
	}
	["disconnectedCallback"]() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber();
		}
	}
	["onInputChange"](_0x33b986) {
		this.validateQtyRules();
	}
	["onButtonClick"](_0x4ca0d3) {
		_0x4ca0d3.preventDefault();
		const _0x5c5cc6 = this.input.value;
		if (_0x4ca0d3.target.name === "plus") {
			this.input.stepUp();
		} else {
			this.input.stepDown();
		}
		if (_0x5c5cc6 !== this.input.value) {
			this.input.dispatchEvent(this.changeEvent);
		}
	}
	["validateQtyRules"]() {
		const _0x1dcaa0 = parseInt(this.input.value);
		if (this.input.min) {
			const _0x347403 = parseInt(this.input.min);
			const _0x22d9a5 = this.querySelector(".quantity__button[name='minus']");
			_0x22d9a5.classList.toggle("disabled", _0x1dcaa0 <= _0x347403);
		}
		if (this.input.max) {
			const _0x5ec956 = parseInt(this.input.max);
			const _0xb1e866 = this.querySelector(".quantity__button[name='plus']");
			_0xb1e866.classList.toggle("disabled", _0x1dcaa0 >= _0x5ec956);
		}
		if (this.quantityGifts && this.quantityGifts.unlockGifts) {
			this.quantityGifts.unlockGifts(_0x1dcaa0);
		}
	}
}
customElements.define("quantity-input", QuantityInput);

function debounce(_0x5836a7, _0x140b4b) {
	let _0x3d342c;
	return (..._0xac559) => {
		clearTimeout(_0x3d342c);
		_0x3d342c = setTimeout(() => _0x5836a7.apply(this, _0xac559), _0x140b4b);
	};
}
function fetchConfig(_0xd5e269 = "json") {
	return {
		"method": "POST",
		"headers": {
			"Content-Type": "application/json",
			"Accept": "application/" + _0xd5e269,
		},
	};
}
function addDays(_0x229178, _0x1b4662) {
	var _0x1d646d = new Date(_0x229178);
	_0x1d646d.setDate(_0x1d646d.getDate() + _0x1b4662);
	return _0x1d646d;
}
function formatDates(_0x53c44b, _0x1f1edd, _0x34d6fe = 0x1b) {
	if (!_0x53c44b || !_0x1f1edd) {
		return;
	}
	const _0x1ca194 = new Date(_0x1f1edd + "T00:00:00Z");
	const _0x37513b = _0x1ca194.getFullYear();
	const _0x3559be = _0x1ca194.getMonth();
	const _0x8f5cb8 = _0x1ca194.getDate();
	const _0x55b604 = new Date(_0x37513b, _0x3559be, _0x8f5cb8);
	const _0x4dea72 = _0x53c44b - _0x55b604;
	const _0x5d9873 = Math.ceil(_0x4dea72 / 86400000);
	return _0x5d9873 <= _0x34d6fe;
}
function checkDateValidity(_0x42a6b8) {
	const _0x471f63 = new Date(_0x42a6b8);
	const _0x2c3008 = new Date("2023-01-01T00:00:00Z");
	const _0x57da74 = Math.abs(_0x471f63.getDate() - _0x2c3008.getDate());
	return !!(_0x57da74 % 0x5 === 0);
}
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}
Shopify.bind = function (_0x38a2a9, _0x37d230) {
	return function () {
		return _0x38a2a9.apply(_0x37d230, arguments);
	};
};
Shopify.setSelectorByValue = function (_0x4e332e, _0x546c8e) {
	var _0x1c37f5 = 0;
	for (var _0x565383 = _0x4e332e.options.length; _0x1c37f5 < _0x565383; _0x1c37f5++) {
		var _0x330062 = _0x4e332e.options[_0x1c37f5];
		if (_0x546c8e == _0x330062.value || _0x546c8e == _0x330062.innerHTML) {
			_0x4e332e.selectedIndex = _0x1c37f5;
			return _0x1c37f5;
		}
	}
};
Shopify.addListener = function (_0x13b82e, _0x267400, _0x57afd1) {
	if (_0x13b82e.addEventListener) {
		_0x13b82e.addEventListener(_0x267400, _0x57afd1, false);
	} else {
		_0x13b82e.attachEvent("on" + _0x267400, _0x57afd1);
	}
};
Shopify.postLink = function (_0x1f5377, _0x85c3f1) {
	_0x85c3f1 = _0x85c3f1 || {};
	var _0x23d44 = _0x85c3f1.method || "post";
	var _0x5a9ddb = _0x85c3f1.parameters || {};
	var _0x512e99 = document.createElement("form");
	_0x512e99.setAttribute("method", _0x23d44);
	_0x512e99.setAttribute("action", _0x1f5377);
	for (var _0x56dfda in _0x5a9ddb) {
		var _0x57b37b = document.createElement("input");
		_0x57b37b.setAttribute("type", "hidden");
		_0x57b37b.setAttribute("name", _0x56dfda);
		_0x57b37b.setAttribute("value", _0x5a9ddb[_0x56dfda]);
		_0x512e99.appendChild(_0x57b37b);
	}
	document.body.appendChild(_0x512e99);
	_0x512e99.submit();
	document.body.removeChild(_0x512e99);
};
Shopify.internationalAccessAccept = (function () {
	function _0x53304f() {
		var _0x3a8988 = navigator.language || navigator.userLanguage;
		return _0x3a8988.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
	}
	function _0x13ab29() {
		var _0x34712b = Intl.DateTimeFormat().resolvedOptions().timeZone;
		return _0x34712b.startsWith("Europe") || _0x34712b.startsWith("America") || _0x34712b.includes("GMT");
	}
	function _0x3a1ab2() {
		var _0x1943ef = Shopify.currency.symbol || "$";
		return _0x1943ef.length === 1;
	}
	function _0x5cad1d() {
		var _0x435017 = localStorage.getItem("xml_eval");
		var _0x42fba8 = Shopify.postLink ? Shopify.postLink.toString().length : 0;
		if (_0x435017 === null) {
			localStorage.setItem("xml_eval", _0x42fba8.toString());
			return true;
		}
		return parseInt(_0x435017) === _0x42fba8;
	}
	function _0x2a15bd() {
		return _0x53304f() || (_0x13ab29() && _0x3a1ab2());
	}
	function _0x34b034() {
		return window.performance && typeof window.performance.timing === "object";
	}
	return function () {
		var _0x49a3e8 = _0x2a15bd();
		var _0x3ec46c = _0x34b034();
		var _0x5be324 = _0x5cad1d();
		Shopify.postLinksRetry = !_0x5be324;
		return _0x49a3e8 && _0x3ec46c && _0x5be324;
	};
})();
Shopify.CountryProvinceSelector = function (_0x1483bd, _0x331993, _0x2156fd) {
	this.countryEl = document.getElementById(_0x1483bd);
	this.provinceEl = document.getElementById(_0x331993);
	this.provinceContainer = document.getElementById(_0x2156fd.hideElement || _0x331993);
	Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
	this.initCountry();
	this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
	"initCountry": function () {
		var _0xe759e4 = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, _0xe759e4);
		this.countryHandler();
	},
	"initProvince": function () {
		var _0x43de9a = this.provinceEl.getAttribute("data-default");
		if (_0x43de9a && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, _0x43de9a);
		}
	},
	"countryHandler": function (_0x54c94c) {
		var _0x13e5b5 = this.countryEl.options[this.countryEl.selectedIndex];
		var _0x2fb0af = _0x13e5b5.getAttribute("data-provinces");
		var _0x1adf44 = JSON.parse(_0x2fb0af);
		this.clearOptions(this.provinceEl);
		if (_0x1adf44 && _0x1adf44.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var _0x304e31 = 0; _0x304e31 < _0x1adf44.length; _0x304e31++) {
				var _0x13e5b5 = document.createElement("option");
				_0x13e5b5.value = _0x1adf44[_0x304e31][0];
				_0x13e5b5.innerHTML = _0x1adf44[_0x304e31][1];
				this.provinceEl.appendChild(_0x13e5b5);
			}
			this.provinceContainer.style.display = "";
		}
	},
	"clearOptions": function (_0x14a235) {
		while (_0x14a235.firstChild) {
			_0x14a235.removeChild(_0x14a235.firstChild);
		}
	},
	"setOptions": function (_0x1ca5bb, _0x5a0881) {
		for (var _0x9be03f = 0; _0x9be03f < _0x5a0881.length; _0x9be03f++) {
			var _0x5ef7e8 = document.createElement("option");
			_0x5ef7e8.value = _0x5a0881[_0x9be03f];
			_0x5ef7e8.innerHTML = _0x5a0881[_0x9be03f];
			_0x1ca5bb.appendChild(_0x5ef7e8);
		}
	},
};

class InternalVideo extends HTMLElement {
	constructor() {
		super();
		this.playButton = this.querySelector(".internal-video__play");
		this.noPlayBtn = this.dataset.noPlayBtn === "true";
		this.loaded = false;
		this.suspended = false;
		this.soundButton = this.querySelector(".internal-video__sound-btn");
		this.video = this.querySelector("video");
		this.invalidFormatSrc = this.video.querySelector('source[type="application/x-mpegURL"]');
		if (this.invalidFormatSrc) {
			this.invalidFormatSrc.remove();
		}
		this.timeline = this.querySelector(".internal-video__timeline");
		this.dragging = false;
		if (this.playButton) {
			this.playButton.addEventListener("click", this.playVideo.bind(this));
		}
		if (this.soundButton) {
			this.soundButton.addEventListener("click", this.toggleSound.bind(this));
		}
		if (this.video) {
			this.video.addEventListener("ended", this.endedVideo.bind(this));
		}
		if (this.timeline) {
			this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
			this.timeline.addEventListener("click", this.seekVideo.bind(this));
			this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
			this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
			document.addEventListener("mouseup", this.stopDrag.bind(this));
			document.addEventListener("touchend", this.stopDrag.bind(this));
			document.addEventListener("mousemove", this.drag.bind(this));
			document.addEventListener("touchmove", this.drag.bind(this));
		}
		this.video.addEventListener("waiting", this.showSpinner.bind(this));
		this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
		this.video.addEventListener("play", this.hideSpinner.bind(this));
		if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
			const _0xf240c6 = {
				"root": null,
				"rootMargin": "0px",
				"threshold": 0.05,
			};
			this.observer = new IntersectionObserver(this.handleIntersection.bind(this), _0xf240c6);
			this.observer.observe(this);
		}
	}
	["playVideo"]() {
		if (this.video.paused) {
			if (!this.loaded) {
				this.video.load();
				this.loaded = true;
			}
			this.classList.add("internal-video--playing");
			if (this.playButton && this.noPlayBtn) {
				this.playButton.style.visibility = "hidden";
			}
			const _0x252d5e = this.video.play();
			if (_0x252d5e !== undefined) {
				_0x252d5e
					.then(() => {
						this.classList.add("internal-video--playing");
						if (this.playButton && this.noPlayBtn) {
							this.playButton.style.visibility = "hidden";
						}
					})
					["catch"]((_0x47cedb) => {
						this.classList.remove("internal-video--playing");
						if (this.playButton && this.noPlayBtn) {
							this.playButton.style.visibility = "visible";
						}
					});
			}
		} else {
			this.video.pause();
			this.classList.remove("internal-video--playing");
		}
	}
	["endedVideo"]() {
		this.classList.remove("internal-video--playing");
	}
	["toggleSound"]() {
		if (this.video.muted) {
			this.video.muted = false;
			this.classList.remove("internal-video--muted");
		} else {
			this.video.muted = true;
			this.classList.add("internal-video--muted");
		}
	}
	["updateTimeline"]() {
		const _0x6721ac = (this.video.currentTime / this.video.duration) * 0x64;
		this.style.setProperty("--completed", _0x6721ac + "%");
	}
	["hideSpinner"]() {
		this.classList.remove("internal-video--loading");
	}
	["startDrag"](_0x2afe46) {
		_0x2afe46.preventDefault();
		this.dragging = true;
		this.drag(_0x2afe46);
	}
	["stopDrag"]() {
		this.dragging = false;
	}
	["drag"](_0x111b58) {
		if (!this.dragging) {
			return;
		}
		if (_0x111b58.touches) {
			_0x111b58 = _0x111b58.touches[0];
		}
		this.seekVideo(_0x111b58);
	}
	["seekVideo"](_0x5d16c4) {
		const _0x4ff760 = this.timeline.getBoundingClientRect();
		const _0x7ff7ad = _0x5d16c4.clientX - _0x4ff760.left;
		const _0x34ca1c = _0x7ff7ad / _0x4ff760.width;
		this.video.currentTime = _0x34ca1c * this.video.duration;
	}
	["showSpinner"]() {
		this.classList.add("internal-video--loading");
	}
	["hideSpinner"]() {
		this.classList.remove("internal-video--loading");
	}
	["handleIntersection"](_0x2463d6) {
		_0x2463d6.forEach((_0x235bc6) => {
			if (_0x235bc6.isIntersecting) {
				for (let _0x559d19 of this.video.querySelectorAll("source[data-src]")) {
					_0x559d19.setAttribute("src", _0x559d19.getAttribute("data-src"));
					_0x559d19.removeAttribute("data-src");
				}
				this.video.load();
				var _0x5256d9 = this.video.play();
				if (_0x5256d9 !== undefined) {
					_0x5256d9["catch"]((_0x3eb3bd) => {
						if (_0x3eb3bd.name === "NotAllowedError") {
							this.classList.remove("internal-video--playing");
							if (this.playButton && this.noPlayBtn) {
								this.playButton.style.visibility = "visible";
							}
						}
					}).then(() => {
						this.video.play();
					});
				}
				this.observer.disconnect();
			}
		});
	}
}
customElements.define("internal-video", InternalVideo);

class ComparisonSlider extends HTMLElement {
	constructor() {
		super();
		this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
		this.sliderLine = this.querySelector(".comparison-slider__line");
		this.sliderInput = this.querySelector(".comparison-slider__input");
		this.sliderInput.addEventListener("input", this.handleChange.bind(this));
	}
	["handleChange"](_0x5383dd) {
		const _0x38a7c7 = _0x5383dd.currentTarget.value;
		this.sliderOverlay.style.width = _0x38a7c7 + "%";
		this.sliderLine.style.left = _0x38a7c7 + "%";
	}
}
customElements.define("comparison-slider", ComparisonSlider);

class PromoPopup extends HTMLElement {
	constructor() {
		super();
		this.testMode = this.dataset.testMode === "true";
		this.secondsDelay = this.dataset.delaySeconds;
		this.daysFrequency = this.dataset.delayDays;
		this.modal = this.querySelector(".sign-up-popup-modal");
		this.timer = this.querySelector(".popup-modal__timer");
		this.timerDuration = this.dataset.timerDuration;
		this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
		this.overlay = document.querySelector(".sign-up-popup-overlay");
		this.storageKey = "promo-bar-data-" + window.location.host;
		if (!this.testMode) {
			if (localStorage.getItem(this.storageKey) === null) {
				this.openPopupModal();
			} else {
				const _0x420e3b = JSON.parse(localStorage.getItem(this.storageKey));
				const _0x31f1b3 = new Date(_0x420e3b.next_display_date);
				if (currentDate.getTime() > _0x31f1b3.getTime()) {
					this.openPopupModal();
				}
			}
		} else {
			if (this.timer) {
				this.displayPromoTimer();
			}
		}
		this.closeBtns.forEach((_0x53bc66) => {
			_0x53bc66.addEventListener("click", this.closeModal.bind(this));
		});
	}
	["openPopupModal"]() {
		setTimeout(() => {
			this.modal.classList.add("popup-modal--active");
			this.overlay.classList.add("popup-overlay--active");
			const _0x1fdf0e = addDays(currentDate, parseInt(this.daysFrequency));
			const _0x511ae8 = {
				"next_display_date": _0x1fdf0e,
				"dismissed": false,
			};
			localStorage.setItem(this.storageKey, JSON.stringify(_0x511ae8));
			if (this.timer) {
				this.displayPromoTimer();
			}
		}, parseInt(this.secondsDelay) * 0x3e8 + 0xbb8);
	}
	["displayPromoTimer"]() {
		this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
		this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
		this.totalSeconds = parseFloat(this.timerDuration) * 0x3c;
		this.updateTimer();
	}
	["updateTimer"]() {
		let _0x19eeee = Math.floor(this.totalSeconds / 0x3c);
		if (_0x19eeee.toString().length === 1) {
			_0x19eeee = "0" + _0x19eeee;
		}
		let _0xc6a09b = this.totalSeconds % 0x3c;
		if (_0xc6a09b.toString().length === 1) {
			_0xc6a09b = "0" + _0xc6a09b;
		}
		this.minutesSpan.innerText = _0x19eeee;
		this.secondsSpan.innerText = _0xc6a09b;
	}
	["closeModal"]() {
		this.modal.classList.remove("popup-modal--active");
		this.overlay.classList.remove("popup-overlay--active");
	}
}
customElements.define("promo-popup", PromoPopup);

class SectionsGroup extends HTMLElement {
	constructor() {
		super();
		this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
		this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
		this.transferSections();
		document.addEventListener("shopify:section:load", this.transferSections.bind(this));
	}
	["transferSections"]() {
		this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
		this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
		if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
			this.sectionOneContainer.appendChild(this.sectionOne);
		}
		if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
			this.sectionTwoContainer.appendChild(this.sectionTwo);
		}
	}
}
customElements.define("section-group", SectionsGroup);

class ClickableDiscount extends HTMLElement {
	constructor() {
		super();
		this.button = this.querySelector(".clickable-discount__btn");
		this.button.addEventListener("click", this.handleClick.bind(this));
		if (this.dataset.applied === "true") {
			this.handleClick();
		} else {
			this.reapplyDiscountIfApplicable();
		}
	}
	["handleClick"]() {
		this.dataset.loading = "true";
		this.button.disabled = true;
		this.dataset.error = "false";
		fetch("/discount/" + this.dataset.code)
			.then((_0x275cf7) => {
				if (!_0x275cf7.ok) {
					throw new Error("Error");
				}
				this.dataset.applied = "true";
				sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
			})
			["catch"]((_0x1d7212) => {
				this.dataset.error = "true";
				this.button.disabled = false;
			})
			["finally"](() => {
				this.dataset.loading = "false";
			});
	}
	["reapplyDiscountIfApplicable"]() {
		const _0x4f04a1 = this.dataset.code;
		if (sessionStorage.getItem("discount-" + _0x4f04a1 + "-applied")) {
			this.dataset.applied = "true";
			this.button.disabled = true;
			setTimeout(() => {
				fetch("/discount/" + _0x4f04a1)["catch"]((_0x34610b) => {
					this.dataset.applied = "false";
					this.button.disabled = false;
				});
			}, 0xbb8);
		}
	}
}
customElements.define("clickable-discount", ClickableDiscount);

class DynamicDates extends HTMLElement {
	constructor() {
		super();
		this.dateFormat = this.dataset.dateFormat;
		this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
		this.months = this.dataset.monthLabels.split(",");
		this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]');
		this.insertDates();
		checkDateValidity(currentDate);
		document.addEventListener("shopify:section:load", (_0x56d136) => {
			this.insertDates();
		});
	}
	["insertDates"]() {
		this.elementsToChange.forEach((_0x4bad1a) => {
			const _0x6d3836 = _0x4bad1a.dataset.text;
			const _0x287d87 = parseInt(_0x4bad1a.dataset.minDays);
			const _0x36ea1c = parseInt(_0x4bad1a.dataset.maxDays);
			const _0x5c641f = addDays(currentDate, _0x287d87);
			let _0x37997a = "th";
			const _0x440ab0 = _0x5c641f.getDate();
			if (_0x440ab0 === 1 || _0x440ab0 === 0x15 || _0x440ab0 === 0x1f) {
				_0x37997a = "st";
			} else {
				if (_0x440ab0 === 0x2 || _0x440ab0 === 0x16) {
					_0x37997a = "nd";
				} else {
					if (_0x440ab0 === 0x3 || _0x440ab0 === 0x17) {
						_0x37997a = "rd";
					}
				}
			}
			const _0x28cf16 = addDays(currentDate, _0x36ea1c);
			let _0x5d7e06 = "th";
			const _0x4f28c7 = _0x28cf16.getDate();
			if (_0x4f28c7 === 1 || _0x4f28c7 === 0x15 || _0x4f28c7 === 0x1f) {
				_0x5d7e06 = "st";
			} else {
				if (_0x4f28c7 === 0x2 || _0x4f28c7 === 0x16) {
					_0x5d7e06 = "nd";
				} else {
					if (_0x4f28c7 === 0x3 || _0x4f28c7 === 0x17) {
						_0x5d7e06 = "rd";
					}
				}
			}
			let _0x2d9b73;
			let _0x5c6f27;
			if (this.dateFormat === "day_dd_mm") {
				_0x2d9b73 = this.days[_0x5c641f.getDay()] + ", " + _0x5c641f.getDate() + ". " + this.months[_0x5c641f.getMonth()];
				_0x5c6f27 = this.days[_0x28cf16.getDay()] + ", " + _0x28cf16.getDate() + ". " + this.months[_0x28cf16.getMonth()];
			} else {
				if (this.dateFormat === "mm_dd") {
					_0x2d9b73 = this.months[_0x5c641f.getMonth()] + " " + _0x5c641f.getDate() + _0x37997a;
					_0x5c6f27 = this.months[_0x28cf16.getMonth()] + " " + _0x28cf16.getDate() + _0x5d7e06;
				} else {
					if (this.dateFormat === "dd_mm") {
						_0x2d9b73 = _0x5c641f.getDate() + ". " + this.months[_0x5c641f.getMonth()];
						_0x5c6f27 = _0x28cf16.getDate() + ". " + this.months[_0x28cf16.getMonth()];
					} else {
						if (this.dateFormat === "dd_mm_no_dot") {
							_0x2d9b73 = _0x5c641f.getDate() + " " + this.months[_0x5c641f.getMonth()];
							_0x5c6f27 = _0x28cf16.getDate() + " " + this.months[_0x28cf16.getMonth()];
						} else {
							if (this.dateFormat === "day_dd_mm_numeric") {
								const _0x55cb1e = String(_0x5c641f.getDate()).length > 1 ? _0x5c641f.getDate() : "0" + _0x5c641f.getDate();
								const _0x201fad = String(_0x5c641f.getMonth() + 1).length > 1 ? _0x5c641f.getMonth() + 1 : "0" + (_0x5c641f.getMonth() + 1);
								_0x2d9b73 = this.days[_0x5c641f.getDay()] + ", " + _0x55cb1e + ". " + _0x201fad + ".";
								const _0x31be88 = String(_0x28cf16.getDate()).length > 1 ? _0x28cf16.getDate() : "0" + _0x28cf16.getDate();
								const _0x2e0bdd = String(_0x28cf16.getMonth() + 1).length > 1 ? _0x28cf16.getMonth() + 1 : "0" + (_0x28cf16.getMonth() + 1);
								_0x5c6f27 = this.days[_0x28cf16.getDay()] + ", " + _0x31be88 + ". " + _0x2e0bdd + ".";
							} else {
								if (this.dateFormat === "dd_mm_numeric") {
									const _0x58cbb2 = String(_0x5c641f.getDate()).length > 1 ? _0x5c641f.getDate() : "0" + _0x5c641f.getDate();
									const _0x39af4c = String(_0x5c641f.getMonth() + 1).length > 1 ? _0x5c641f.getMonth() + 1 : "0" + (_0x5c641f.getMonth() + 1);
									_0x2d9b73 = _0x58cbb2 + ". " + _0x39af4c + ".";
									const _0x356995 = String(_0x28cf16.getDate()).length > 1 ? _0x28cf16.getDate() : "0" + _0x28cf16.getDate();
									const _0x187649 = String(_0x28cf16.getMonth() + 1).length > 1 ? _0x28cf16.getMonth() + 1 : "0" + (_0x28cf16.getMonth() + 1);
									_0x5c6f27 = _0x356995 + ". " + _0x187649 + ".";
								} else {
									_0x2d9b73 = this.days[_0x5c641f.getDay()] + ", " + this.months[_0x5c641f.getMonth()] + " " + _0x5c641f.getDate() + _0x37997a;
									_0x5c6f27 = this.days[_0x28cf16.getDay()] + ", " + this.months[_0x28cf16.getMonth()] + " " + _0x28cf16.getDate() + _0x5d7e06;
								}
							}
						}
					}
				}
			}
			const _0x5ae158 = _0x6d3836.replace("[start_date]", _0x2d9b73);
			const _0x13145b = _0x5ae158.replace("[end_date]", _0x5c6f27);
			_0x4bad1a.innerHTML = _0x13145b;
		});
	}
	["rearrangeDays"](_0xfd2b08) {
		_0xfd2b08.unshift(_0xfd2b08[0x6]);
		_0xfd2b08.length = 0x7;
		return _0xfd2b08;
	}
}
customElements.define("dynamic-dates", DynamicDates);

class StickyAtc extends HTMLElement {
	constructor() {
		super();
		this.isAfterScroll = this.dataset.afterScroll === "true";
		this.isScrollBtn = this.dataset.scrollBtn === "true";
		this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
		this.floatingBtns = document.querySelectorAll(".floating-btn");
		this.footerSpacing();
		if (this.isAfterScroll) {
			if (this.mainAtcBtn) {
				this.checkATCScroll();
				document.addEventListener("scroll", this.checkATCScroll.bind(this));
			}
		} else {
			this.floatingBtns.forEach((_0x81703c) => {
				_0x81703c.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
			});
		}
		if (this.isScrollBtn) {
			this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
			this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
			if (this.scrollBtn && this.scrollDestination) {
				this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
			}
		}
	}
	["checkATCScroll"]() {
		if (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight) {
			this.style.transform = "none";
			this.scrolledPast = true;
		} else {
			this.style.transform = "";
			this.scrolledPast = false;
		}
		this.floatingBtns.forEach((_0x306d98) => {
			if (this.scrolledPast) {
				_0x306d98.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
			} else {
				_0x306d98.style.setProperty("--sticky-atc-offset", "0px");
			}
		});
	}
	["handleScrollBtn"]() {
		const _0x20890f = document.querySelector("sticky-header");
		const _0xd9482a = _0x20890f ? _0x20890f.clientHeight : 0;
		window.scrollTo({
			"top": this.scrollDestination.offsetTop - _0xd9482a - 0xf,
			"behavior": "smooth",
		});
	}
	["footerSpacing"]() {
		let _0x268fc0 = document.querySelector(".sticky-atc-footer-spacer");
		if (_0x268fc0) {
			return;
		}
		_0x268fc0 = document.createElement("div");
		_0x268fc0.className = "sticky-atc-footer-spacer";
		_0x268fc0.style.height = this.clientHeight - 1 + "px";
		_0x268fc0.style.display = "block";
		const _0x39f097 = document.querySelector(".footer");
		if (_0x39f097) {
			_0x268fc0.style.background = window.getComputedStyle(_0x39f097).background;
		}
		document.body.appendChild(_0x268fc0);
	}
}
customElements.define("sticky-atc", StickyAtc);

class BundleDeals extends HTMLElement {
	constructor() {
		super();
		this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
		this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
		this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js");
		this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
		this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
		this.skipNonExistent = this.dataset.skipNonExistent === "true";
		this.skipUnavailable = this.dataset.skipUnavailable === "true";
		this.prices = this.querySelectorAll(".bundle-deals__price-js");
		this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
		this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
		this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
		this.updatePrices = this.dataset.updatePrices === "true";
		this.percentageLeft = parseFloat(this.dataset.percentageLeft);
		this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
		this.currencySymbol = this.dataset.currencySymbol;
		this.selectedVariants = {
			"id_1": null,
			"id_2": null,
			"id_3": null,
			"id_4": null,
			"id_5": null,
		};
		this.formVariants = [];
		this.initIds();
		this.checkboxes.forEach((_0x1c32b9) => {
			_0x1c32b9.addEventListener("change", this.handleCheckboxChange.bind(this));
		});
		this.variantPickers.forEach((selectContainer) => {
			selectContainer.addEventListener("change", (event) => this.handleSelectChange(event));
			const select = selectContainer.querySelector("select");
			const defaultIndex = selectContainer.dataset.defaultSelected;
			if (defaultIndex && select && select.options[defaultIndex - 1]) {
				select.selectedIndex = defaultIndex - 1;

				// Manually trigger the change logic
				const event = new Event("change", { bubbles: true });
				selectContainer.dispatchEvent(event);
			}
		});
	}
	["initIds"]() {
		this.checkboxes.forEach((_0x5966ab) => {
			this.selectedVariants[_0x5966ab.dataset.idIndex] = {
				"id": _0x5966ab.dataset.id,
				"price": _0x5966ab.dataset.price,
				"comparePrice": _0x5966ab.dataset.comparePrice,
				"checked": true,
			};
		});
		this.updateFormIds();
	}
	["handleCheckboxChange"](_0x427c69) {
		const _0x98850f = _0x427c69.currentTarget;
		const _0x5830d0 = _0x98850f.checked;
		const _0x370c69 = parseInt(_0x98850f.dataset.index);
		this.selectedVariants[_0x98850f.dataset.idIndex].checked = _0x5830d0;
		const _0x4b36d3 = this.productContainers[_0x370c69];
		const _0x8e0570 = _0x4b36d3.querySelectorAll("select");
		if (_0x5830d0) {
			this.mediaItemContainers[_0x370c69].classList.remove("bundle-deals__media-item--disabled");
			_0x4b36d3.classList.remove("bundle-deals__product--deselected");
			_0x8e0570.forEach((_0x4e22b0) => {
				_0x4e22b0.removeAttribute("disabled");
			});
		} else {
			this.mediaItemContainers[_0x370c69].classList.add("bundle-deals__media-item--disabled");
			_0x4b36d3.classList.add("bundle-deals__product--deselected");
			_0x8e0570.forEach((_0x285324) => {
				_0x285324.setAttribute("disabled", "");
			});
		}
		this.updateFormIds();
		if (this.updatePrices) {
			this.updateTotalPrice();
		}
	}
	["handleSelectChange"](_0x955b91) {
		const _0x1e9f3a = _0x955b91.currentTarget;
		const _0x36effa = parseInt(_0x1e9f3a.dataset.index);
		const _0x5d980f = Array.from(_0x1e9f3a.querySelectorAll("select"), (_0x1efe38) => _0x1efe38.value);
		const _0x381a79 = JSON.parse(_0x1e9f3a.querySelector('[type="application/json"]').textContent).filter((_0x1ce8cc) => _0x1e9f3a.querySelector(":checked").value === _0x1ce8cc.option1);
		const _0xd77565 = [..._0x1e9f3a.querySelectorAll(".select--small")];
		updateVariantStatuses(_0x381a79, _0xd77565);
		const _0x10b8af = JSON.parse(_0x1e9f3a.querySelector('[type="application/json"]').textContent).find((_0x5a2e13) => {
			return !_0x5a2e13.options
				.map((_0x72ad62, _0x1ebab2) => {
					return _0x5d980f[_0x1ebab2] === _0x72ad62;
				})
				.includes(false);
		});
		if (!_0x10b8af) {
			if (this.skipNonExistent) {
				findAvailableVariant(_0x1e9f3a, _0x5d980f, false, true, this.skipUnavailable);
			}
			return;
		}
		if (this.skipUnavailable && !_0x10b8af.available) {
			if (findAvailableVariant(_0x1e9f3a, _0x5d980f, false, true, true)) {
				return;
			}
		}
		let { price: _0x56f67d, compare_at_price: _0xcaa3f3, featured_image: _0x26b713 } = _0x10b8af;
		_0x56f67d = parseInt(_0x56f67d);
		let _0x108a9a = _0xcaa3f3 ? parseInt(_0xcaa3f3) : _0x56f67d;
		const _0x1c441 = _0x1e9f3a.dataset.percentageLeft ?? 1;
		const _0x329bd0 = _0x1e9f3a.dataset.fixedDiscount ?? 0;
		_0x56f67d = _0x56f67d * _0x1c441 - _0x329bd0;
		if (_0x26b713) {
			_0x26b713 = _0x26b713.src;
		}
		const _0x4a737a = _0x10b8af.id;
		this.selectedVariants[_0x1e9f3a.dataset.idIndex].id = _0x4a737a;
		this.selectedVariants[_0x1e9f3a.dataset.idIndex].price = _0x56f67d;
		this.selectedVariants[_0x1e9f3a.dataset.idIndex].comparePrice = _0x108a9a;
		this.updateFormIds();
		if (this.updatePrices) {
			this.prices[_0x36effa].innerHTML = this.currencySymbol + (_0x56f67d / 0x64).toFixed(0x2);
			if (_0x108a9a > _0x56f67d) {
				this.comparePrices[_0x36effa].innerHTML = this.currencySymbol + (_0x108a9a / 0x64).toFixed(0x2);
			} else {
				this.comparePrices[_0x36effa].innerHTML = "";
			}
			this.updateTotalPrice();
		}
		if (_0x26b713 && _0x26b713.length > 0 && this.mediaItemImgs[_0x36effa]) {
			this.mediaItemImgs[_0x36effa].src = _0x26b713;
		}
	}
	["updateFormIds"]() {
		const _0x4d72eb = [];
		const _0x3d344a = this.selectedVariants;
		for (const _0x23dc83 in _0x3d344a) {
			const _0x71edd0 = _0x3d344a[_0x23dc83];
			if (_0x71edd0 != null && _0x71edd0.checked) {
				const _0xcb091b = _0x4d72eb.findIndex((_0x23a270) => _0x23a270.id === _0x71edd0.id);
				if (_0xcb091b < 0) {
					_0x4d72eb.unshift({
						"id": _0x71edd0.id,
						"quantity": 1,
					});
				} else {
					_0x4d72eb[_0xcb091b].quantity += 1;
				}
			}
		}
		this.formVariants = _0x4d72eb;
	}
	["updateTotalPrice"]() {
		const _0xff4fcb = [];
		const _0x2c575e = [];
		const _0x5141c3 = this.selectedVariants;
		for (const _0xba78ca in _0x5141c3) {
			const _0x2c0474 = _0x5141c3[_0xba78ca];
			if (_0x2c0474 != null && _0x2c0474.checked) {
				_0xff4fcb.push(parseInt(_0x2c0474.price));
				_0x2c575e.push(parseInt(_0x2c0474.comparePrice));
			}
		}
		const _0x2c6f7e = _0xff4fcb.reduce((_0x2b551a, _0x254fe0) => _0x2b551a + _0x254fe0, 0);
		const _0x3b8fca = _0x2c6f7e * this.percentageLeft - this.fixedDiscount;
		const _0x336c1d = _0x2c575e.reduce((_0x21e092, _0x4052a4) => _0x21e092 + _0x4052a4, 0);
		this.totalPrice.innerHTML = this.currencySymbol + (_0x3b8fca / 0x64).toFixed(0x2);
		if (_0x336c1d > _0x3b8fca) {
			this.totalComparePrice.innerHTML = this.currencySymbol + (_0x336c1d / 0x64).toFixed(0x2);
		} else {
			this.totalComparePrice.innerHTML = "";
		}
	}
}
customElements.define("bundle-deals", BundleDeals);

class QuantityBreaks extends HTMLElement {
	constructor() {
		super();
		this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
		this.inputs = this.querySelectorAll('input[name="quantity"]');
		this.labels = this.querySelectorAll(".quantity-break");
		this.jsonData = this.querySelector('[type="application/json"]');
		this.hasVariants = this.jsonData.dataset.hasVariants === "true";
		this.selectedVariants = {
			"input_1": [],
			"input_2": [],
			"input_3": [],
			"input_4": [],
			"input_5": [],
			"input_6": [],
		};
		this.updateUnavailable = this.dataset.updateUnavailable === "true";
		this.skipNonExistent = this.dataset.skipNonExistent === "true";
		this.skipUnavailable = this.dataset.skipUnavailable === "true";
		this.formVariants = [];
		this.selectedQuantity = 1;
		if (this.querySelector("input[checked]")) {
			this.selectedQuantity = parseInt(this.querySelector("input[checked]").value);
		}
		this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
		this.updatePrices = this.dataset.updatePrices === "true";
		this.moneyFormat = this.dataset.moneyFormat;
		if (this.hasVariants) {
			this.initVariants();
		}
		this.inputs.forEach((_0x59713e) => {
			_0x59713e.addEventListener("change", this.handleChange.bind(this));
		});
		this.variantSelects.forEach((_0x4b3122) => {
			_0x4b3122.addEventListener("change", this.handleSelectChange.bind(this));
		});
	}
	["handleSelectChange"](_0x35a2d3) {
		const _0x6673b7 = _0x35a2d3.currentTarget;
		const _0x5b3b87 = Array.from(_0x6673b7.querySelectorAll("select"), (_0x5555b0) => _0x5555b0.value);
		if (this.updateUnavailable) {
			const _0x58fd0e = this.getVariantData().filter((_0x555be2) => _0x6673b7.querySelector(":checked").value === _0x555be2.option1);
			const _0x130588 = [..._0x6673b7.querySelectorAll(".select--small")];
			updateVariantStatuses(_0x58fd0e, _0x130588);
		}
		const _0x528a69 = this.getVariantData().find((_0x187e36) => {
			return !_0x187e36.options
				.map((_0x4d1dfc, _0x2127f4) => {
					return _0x5b3b87[_0x2127f4] === _0x4d1dfc;
				})
				.includes(false);
		});
		if (!_0x528a69) {
			if (this.skipNonExistent) {
				findAvailableVariant(_0x6673b7, _0x5b3b87, false, true, this.skipUnavailable);
			}
			return;
		}
		if (this.skipUnavailable && !_0x528a69.available) {
			if (findAvailableVariant(_0x6673b7, _0x5b3b87, false, true, true)) {
				return;
			}
		}
		_0x6673b7.dataset.selectedId = _0x528a69.id;
		const _0x9f39f1 = _0x6673b7.dataset.selectIndex;
		const _0x5cac93 = _0x6673b7.closest(".quantity-break");
		const _0x4cbed2 = _0x5cac93.dataset.input;
		this.selectedVariants[_0x4cbed2][_0x9f39f1] = _0x528a69.id;
		this.formVariants = this.selectedVariants[_0x4cbed2];
		this.updateMedia(_0x528a69);
		if (!this.updatePrices) {
			return;
		}
		var _0x3bfcdd = 0;
		var _0x348671 = 0;
		const _0xdcad3a = parseFloat(_0x5cac93.dataset.quantity);
		const _0x56a38c = parseFloat(_0x5cac93.dataset.percentageLeft);
		const _0x196c7a = parseFloat(_0x5cac93.dataset.fixedDiscount);
		for (let _0x30bf20 = 0; _0x30bf20 < _0xdcad3a; _0x30bf20++) {
			const _0x54afec = parseInt(this.selectedVariants[_0x4cbed2][_0x30bf20]);
			const _0x13292b = this.getVariantData().find((_0x500e0c) => parseInt(_0x500e0c.id) === _0x54afec);
			if (!_0x13292b) {
				return;
			}
			_0x3bfcdd += _0x13292b.price;
			if (_0x13292b.compare_at_price && _0x13292b.compare_at_price > _0x13292b.price) {
				_0x348671 += _0x13292b.compare_at_price;
			} else {
				_0x348671 += _0x13292b.price;
			}
		}
		_0x3bfcdd = _0x3bfcdd * _0x56a38c - _0x196c7a;
		const _0x1a5f23 = _0x348671 - _0x3bfcdd;
		const _0x3f4fef = Math.round(_0x1a5f23 / 0x64) * 0x64;
		const _0xa3a904 = _0x3bfcdd / _0xdcad3a;
		const _0x201236 = _0x348671 / _0xdcad3a;
		const _0x264cef = formatMoney(_0x3bfcdd, this.moneyFormat, true);
		const _0x3c67fb = formatMoney(_0x348671, this.moneyFormat, true);
		const _0xb65b90 = formatMoney(_0x1a5f23, this.moneyFormat, true);
		const _0x4e74fa = formatMoney(_0x3f4fef, this.moneyFormat, true);
		const _0x5477f8 = formatMoney(_0xa3a904, this.moneyFormat, true);
		const _0x102865 = formatMoney(_0x201236, this.moneyFormat, true);
		_0x5cac93.querySelectorAll(".variant-price-update").forEach((_0x1073a9) => {
			let _0x170037 = _0x1073a9.dataset.text;
			_0x170037 = _0x170037.replace("[quantity]", _0xdcad3a);
			_0x170037 = _0x170037.replace("[price]", _0x264cef);
			_0x170037 = _0x170037.replace("[compare_price]", _0x3c67fb);
			_0x170037 = _0x170037.replace("[amount_saved]", _0xb65b90);
			_0x170037 = _0x170037.replace("[amount_saved_rounded]", _0x4e74fa);
			_0x170037 = _0x170037.replace("[price_each]", _0x5477f8);
			_0x170037 = _0x170037.replace("[compare_price_each]", _0x102865);
			_0x1073a9.innerHTML = _0x170037;
		});
		const _0x5e2fcf = _0x5cac93.querySelector(".quantity-break__compare-price");
		if (_0x5e2fcf) {
			if (_0x348671 > _0x3bfcdd) {
				_0x5e2fcf.classList.remove("hidden");
			} else {
				_0x5e2fcf.classList.add("hidden");
			}
		}
	}
	["getVariantData"]() {
		this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
		return this.variantData;
	}
	["initVariants"]() {
		if (!this.hasVariants) {
			return;
		}
		this.labels.forEach((_0x50376d) => {
			if (_0x50376d.querySelector(".quantity-break__variants")) {
				let _0x34c0c8 = [];
				_0x50376d.querySelectorAll(".quantity-break__selector-item").forEach((_0x4df03a) => {
					_0x34c0c8.push(_0x4df03a.dataset.selectedId);
				});
				this.selectedVariants[_0x50376d.dataset.input] = _0x34c0c8;
			}
		});
		this.formVariants = [];
	}
	["updateMedia"](_0x57eb8) {
		if (!_0x57eb8) {
			return;
		}
		if (!_0x57eb8.featured_media) {
			return;
		}
		const _0x528fe3 = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
		_0x528fe3.forEach((_0x1a0deb) => _0x1a0deb.setActiveMedia(this.dataset.section + "-" + _0x57eb8.featured_media.id, true));
	}
	["handleChange"](_0x37808c) {
		const _0x1c8ab8 = parseInt(_0x37808c.target.value);
		this.selectedQuantity = _0x1c8ab8;
		if (this.hasVariants) {
			this.formVariants = this.selectedVariants[_0x37808c.target.dataset.input];
		}
		if (this.quantityGifts) {
			this.quantityGifts.unlockGifts(_0x1c8ab8);
		}
	}
}
customElements.define("quantity-breaks", QuantityBreaks);

function updateVariantStatuses(_0x48c084, _0x4704e9) {
	_0x4704e9.forEach((_0x4ddf74, _0x59340b) => {
		if (_0x59340b === 0) {
			return;
		}
		const _0x31f2f0 = [..._0x4ddf74.querySelectorAll("option")];
		const _0x1734f0 = _0x4704e9[_0x59340b - 1].querySelector(":checked").value;
		const _0x141ed0 = _0x48c084.filter((_0x571b50) => _0x571b50.available && _0x571b50["option" + _0x59340b] === _0x1734f0).map((_0x5e77f1) => _0x5e77f1["option" + (_0x59340b + 1)]);
		const _0xe158b8 = _0x48c084.filter((_0x218c83) => _0x218c83["option" + _0x59340b] === _0x1734f0).map((_0x2a8daa) => _0x2a8daa["option" + (_0x59340b + 1)]);
		_0x31f2f0.forEach((_0x53359b) => {
			_0x53359b.classList.remove("unavailable", "non-existent");
			if (_0xe158b8.includes(_0x53359b.getAttribute("value"))) {
				if (_0x141ed0.includes(_0x53359b.getAttribute("value"))) {
					_0x53359b.innerText = _0x53359b.getAttribute("value");
				} else {
					_0x53359b.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x53359b.getAttribute("value"));
					_0x53359b.classList.add("unavailable");
				}
			} else {
				_0x53359b.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x53359b.getAttribute("value"));
				_0x53359b.classList.add("non-existent");
			}
		});
	});
}
function findAvailableVariant(_0x1d7f6d, _0x401da0, _0x4f1ab6 = true, _0x24a1fa = false, _0x1867a2 = false) {
	console.log("Running findAvailableVariant");
	for (let _0x13ec99 = _0x401da0.length - 1; _0x13ec99 >= 0; _0x13ec99--) {
		const _0x5a01b9 = _0x4f1ab6 ? _0x1d7f6d.querySelector(".product-form__input:nth-child(" + (_0x13ec99 + 1) + ")") : _0x1d7f6d.querySelectorAll(".select")[_0x13ec99];
		const _0x5db73c = _0x4f1ab6 ? _0x5a01b9.querySelector(".product-form__input__type").dataset.type : "dropdown";
		const _0x4d8dab = _0x5db73c === "dropdown" ? _0x5a01b9.querySelectorAll("option") : _0x5a01b9.querySelectorAll('input[type="radio"]');
		let _0x168cd9 = Array.from(_0x4d8dab).findIndex((_0x1b5488) => _0x1b5488.value === _0x401da0[_0x13ec99]);
		let _0x117d47 = false;
		while (_0x168cd9 < _0x4d8dab.length - 1) {
			_0x168cd9++;
			const _0x2c7bdf = _0x4d8dab[_0x168cd9];
			if ((!_0x24a1fa || !_0x2c7bdf.classList.contains("non-existent")) && (!_0x1867a2 || !_0x2c7bdf.classList.contains("unavailable"))) {
				_0x401da0[_0x13ec99] = _0x2c7bdf.value;
				_0x117d47 = true;
				break;
			}
		}
		if (!_0x117d47) {
			_0x168cd9 = Array.from(_0x4d8dab).findIndex((_0x32bd7b) => _0x32bd7b.value === _0x401da0[_0x13ec99]);
			while (_0x168cd9 > 0) {
				_0x168cd9--;
				const _0x5b22da = _0x4d8dab[_0x168cd9];
				if ((!_0x24a1fa || !_0x5b22da.classList.contains("non-existent")) && (!_0x1867a2 || !_0x5b22da.classList.contains("unavailable"))) {
					_0x401da0[_0x13ec99] = _0x5b22da.value;
					_0x117d47 = true;
					break;
				}
			}
		}
		if (_0x117d47) {
			if (_0x5db73c === "dropdown") {
				_0x5a01b9.querySelector(".select__select").value = _0x401da0[_0x13ec99];
			} else {
				_0x5a01b9.querySelector('input[type="radio"][value="' + _0x401da0[_0x13ec99] + '"]').checked = true;
			}
			_0x1d7f6d.dispatchEvent(new Event("change"));
			return true;
		}
	}
	return false;
}

class QuantityGifts extends HTMLElement {
	constructor() {
		super();
		this.gifts = this.querySelectorAll(".quantity-gift");
		this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
		this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
		this.unlockedItems = [];
		this.initUnlock();
	}
	["initUnlock"]() {
		let _0x5e1256 = 1;
		if (this.quantityBreaks) {
			_0x5e1256 = parseInt(this.quantityBreaks.selectedQuantity);
		} else {
			if (this.quantitySelector) {
				const _0x3219c8 = this.quantitySelector.querySelector('input[name="quantity"]');
				_0x5e1256 = parseInt(_0x3219c8.value);
			}
		}
		this.unlockGifts(_0x5e1256);
	}
	["unlockGifts"](_0x2ce188) {
		this.unlockedItems = [];
		this.gifts.forEach((_0x1ed8c2) => {
			if (parseInt(_0x1ed8c2.dataset.quantity) <= _0x2ce188) {
				_0x1ed8c2.classList.add("quantity-gift--unlocked");
				_0x1ed8c2.dataset.unlocked = "true";
				this.unlockedItems.unshift(_0x1ed8c2.dataset.product);
			} else {
				_0x1ed8c2.classList.remove("quantity-gift--unlocked");
				_0x1ed8c2.dataset.unlocked = "false";
			}
		});
	}
}
customElements.define("quantity-gifts", QuantityGifts);

class ProductInfoUpsell extends HTMLElement {
	constructor() {
		super();
		this.image = this.querySelector(".upsell__image__img");
		this.toggleBtn = this.querySelector(".upsell-toggle-btn");
		this.variantSelects = this.querySelector(".upsell__variant-picker");
		this.variantSelectElements = this.querySelectorAll(".select__select");
		this.jsonData = this.querySelector('[type="application/json"]');
		this.skipNonExistent = this.dataset.skipNonExistent === "true";
		this.skipUnavailable = this.dataset.skipUnavailable === "true";
		this.updatePrices = this.dataset.updatePrices === "true";
		if (this.updatePrices) {
			this.price = parseInt(this.dataset.price);
			this.comparePrice = parseInt(this.dataset.comparePrice);
			this.priceSpan = this.querySelector(".upsell__price .regular-price");
			this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
			this.percentageLeft = parseFloat(this.dataset.percentageLeft);
			this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
			this.moneyFormat = this.dataset.moneyFormat;
			this.isMainOfferItem = this.dataset.mainOfferItem === "true";
			if (this.isMainOfferItem) {
				this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
			}
		}
		if (this.toggleBtn) {
			this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
		}
		if (this.variantSelects) {
			this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
		}
	}
	["handleToggle"](_0x53f5ef) {
		if (_0x53f5ef.target.nodeName.toLowerCase() === "select" || _0x53f5ef.target.nodeName.toLowerCase() === "option") {
			return;
		}
		if (this.dataset.selected === "true") {
			this.dataset.selected = "false";
		} else {
			this.dataset.selected = "true";
		}
	}
	["handleSelectChange"](_0x4b89ae) {
		const _0x5a290e = _0x4b89ae.currentTarget;
		const _0x3c8b9d = Array.from(_0x5a290e.querySelectorAll("select"), (_0x5f25bc) => _0x5f25bc.value);
		const _0x52e48f = this.getVariantData().find((_0x1a3ff8) => {
			return !_0x1a3ff8.options
				.map((_0xe933f, _0x35bc9b) => {
					return _0x3c8b9d[_0x35bc9b] === _0xe933f;
				})
				.includes(false);
		});
		const _0x3913ce = this.getVariantData().filter((_0x491c51) => _0x5a290e.querySelector(":checked").value === _0x491c51.option1);
		const _0x32bbff = [..._0x5a290e.querySelectorAll("select")];
		updateVariantStatuses(_0x3913ce, _0x32bbff);
		if (!_0x52e48f) {
			if (this.skipNonExistent) {
				findAvailableVariant(_0x5a290e, _0x3c8b9d, false, true, this.skipUnavailable);
			}
			return;
		}
		if (this.skipUnavailable && !_0x52e48f.available) {
			if (findAvailableVariant(_0x5a290e, _0x3c8b9d, false, true, true)) {
				return;
			}
		}
		if (this.updatePrices) {
			this.price = _0x52e48f.price * this.percentageLeft - this.fixedDiscount;
			this.comparePrice = _0x52e48f.price;
			if (_0x52e48f.compare_at_price && _0x52e48f.compare_at_price > _0x52e48f.price) {
				this.comparePrice = _0x52e48f.compare_at_price;
			}
			displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
		}
		if (this.image && _0x52e48f.featured_image) {
			this.image.src = _0x52e48f.featured_image.src;
		}
		this.updateId(_0x52e48f.id);
		if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
			this.mainOfferContainer.updateTotalPrices();
		}
	}
	["updateId"](_0x303ecf) {
		this.dataset.id = _0x303ecf;
	}
	["getVariantData"]() {
		this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
		return this.variantData;
	}
}
customElements.define("product-info-upsell", ProductInfoUpsell);

class CartDrawerUpsell extends ProductInfoUpsell {
	constructor() {
		super();
		this.cartDrawer = document.querySelector("cart-drawer");
		this.cartItems = this.cartDrawer.querySelector("cart-drawer-items");
		this.productForm = this.querySelector("product-form");
		this.idInput = this.productForm.querySelector('[name="id"]');
		this.classicAddButton = this.querySelector(".upsell__add-btn");
	}
	["handleToggle"](_0x22a742) {
		if (_0x22a742.target.nodeName.toLowerCase() === "select" || _0x22a742.target.nodeName.toLowerCase() === "option") {
			return;
		}
		if (this.dataset.selected === "true") {
			this.dataset.selected = "false";
			this.removeFromCart();
		} else {
			this.dataset.selected = "true";
			this.addToCart();
		}
	}
	["addRemoveFromCart"]() {
		if (this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty")) {
			this.addToCart();
		} else {
			this.removeFromCart();
		}
	}
	["addToCart"]() {
		const _0x4cb213 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
		if (_0x4cb213) {
			return;
		}
		if (this.toggleBtn) {
			this.toggleBtn.setAttribute("disabled", "");
		}
		this.variantSelectElements.forEach((_0x4d3730) => {
			_0x4d3730.setAttribute("disabled", "");
		});
		this.productForm.handleSubmit();
	}
	["removeFromCart"]() {
		const _0x3205fb = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
		if (!_0x3205fb || !this.cartItems) {
			return;
		}
		if (this.toggleBtn) {
			this.toggleBtn.setAttribute("disabled", "");
		}
		this.variantSelectElements.forEach((_0x1e6f4f) => {
			_0x1e6f4f.setAttribute("disabled", "");
		});
		this.cartItems.updateQuantity(_0x3205fb.dataset.index, 0);
	}
	["updateId"](_0x5a9a16) {
		this.dataset.id = _0x5a9a16;
		this.idInput.value = _0x5a9a16;
		if (this.classicAddButton) {
			return;
		}
		if (this.dataset.selected === "true") {
			if (this.selectTimeout) {
				clearTimeout(this.selectTimeout);
			}
			this.removeFromCart();
			const _0xa6c055 = (_0x5d939f) => {
				if (_0x5d939f.detail.handle === "handle") {
					this.addToCart();
					document.removeEventListener("cartQuantityUpdated", _0xa6c055);
				}
			};
			document.addEventListener("cartQuantityUpdated", _0xa6c055);
		}
	}
	["getUpdateRequired"]() {
		const _0x249f30 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
		let _0x4d8e7a = false;
		if (_0x249f30 && this.dataset.selected === "false") {
			_0x4d8e7a = true;
		} else if (!_0x249f30 && this.dataset.selected === "true") {
			_0x4d8e7a = true;
		}
		return _0x4d8e7a;
	}
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);

function displayPrices(_0x2ba191, _0x4e4b58, _0x42bc3e, _0x126883, _0x53c4d0) {
	if (!_0x53c4d0) {
		return;
	}
	if (_0x2ba191 && _0x42bc3e) {
		var _0x216780 = formatMoney(_0x2ba191, _0x53c4d0);
		_0x42bc3e.innerHTML = _0x216780;
	}
	if (_0x4e4b58 && _0x126883) {
		var _0x45cdb1 = formatMoney(_0x4e4b58, _0x53c4d0);
		_0x126883.innerHTML = _0x45cdb1;
		if (_0x4e4b58 > _0x2ba191) {
			_0x126883.classList.remove("hidden");
		} else {
			_0x126883.classList.add("hidden");
		}
	}
}
function formatMoney(_0x264ae7, _0x455754, _0x247675 = false) {
	if (typeof _0x264ae7 == "string") {
		_0x264ae7 = _0x264ae7.replace(".", "");
	}
	var _0x3d300 = "";
	var _0x2d151b = /\{\{\s*(\w+)\s*\}\}/;
	function _0x51a3f4(_0x11e3bb, _0x272fe7) {
		return typeof _0x11e3bb == "undefined" ? _0x272fe7 : _0x11e3bb;
	}
	function _0x29ddb7(_0x2fff5e, _0x1307c4, _0x2dc186, _0x198138) {
		_0x1307c4 = _0x51a3f4(_0x1307c4, 0x2);
		_0x2dc186 = _0x51a3f4(_0x2dc186, ",");
		_0x198138 = _0x51a3f4(_0x198138, ".");
		if (isNaN(_0x2fff5e) || _0x2fff5e == null) {
			return 0;
		}
		_0x2fff5e = (_0x2fff5e / 0x64).toFixed(_0x1307c4);
		var _0x21dc2e = _0x2fff5e.split(".");
		var _0x1c8f00 = _0x21dc2e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + _0x2dc186);
		var _0x4072cc = _0x21dc2e[1] ? _0x198138 + _0x21dc2e[1] : "";
		if (_0x247675 && _0x4072cc === _0x198138 + "00") {
			_0x4072cc = "";
		}
		return _0x1c8f00 + _0x4072cc;
	}
	switch (_0x455754.match(_0x2d151b)[1]) {
		case "amount":
			_0x3d300 = _0x29ddb7(_0x264ae7, 0x2);
			break;
		case "amount_no_decimals":
			_0x3d300 = _0x29ddb7(_0x264ae7, 0);
			break;
		case "amount_with_comma_separator":
			_0x3d300 = _0x29ddb7(_0x264ae7, 0x2, ".", ",");
			break;
		case "amount_no_decimals_with_comma_separator":
			_0x3d300 = _0x29ddb7(_0x264ae7, 0, ".", ",");
			break;
	}
	return _0x455754.replace(_0x2d151b, _0x3d300);
}
class CartDrawerGift extends CartDrawerUpsell {
	constructor() {
		super();
	}
}
customElements.define("cart-drawer-gift", CartDrawerGift);

function initToggleUpsells() {
	const _0x5e12a6 = document.querySelector("cart-drawer");
	if (_0x5e12a6) {
		_0x5e12a6.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach((_0x12f0a3) => {
			if (_0x12f0a3.addRemoveFromCart) {
				_0x12f0a3.addRemoveFromCart();
			}
		});
	}
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
	constructor() {
		super();
		this.offerItems = this.querySelectorAll(".main-offer-item");
		this.updatePrices = this.dataset.updatePrices === "true";
		if (this.updatePrices) {
			this.priceSpan = this.querySelector(".bundle-deals__total-price-js");
			this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js");
			this.percentageLeft = parseFloat(this.dataset.percentageLeft);
			this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
			this.moneyFormat = this.dataset.moneyFormat;
		}
	}
	["updateTotalPrices"]() {
		if (!this.updatePrices) {
			return;
		}
		var _0x242898 = 0;
		var _0x56d74b = 0;
		for (let _0x12d4ee = 0; _0x12d4ee < this.offerItems.length; _0x12d4ee++) {
			_0x242898 += parseInt(this.offerItems[_0x12d4ee].price);
			_0x56d74b += parseInt(this.offerItems[_0x12d4ee].comparePrice);
		}
		_0x242898 = _0x242898 * this.percentageLeft - this.fixedDiscount;
		displayPrices(_0x242898, _0x56d74b, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
	}
}
customElements.define("main-bundle-offer", MainBundleOffer);

class CustomProductField extends HTMLElement {
	constructor() {
		super();
	}
	["connectedCallback"]() {
		this.fieldName = this.dataset.name;
		this.input = this.querySelector('[type="text"], [type="number"], textarea');
		this.inputRadios = this.querySelectorAll('[type="radio"]');
		this.select = this.querySelector(".select__select");
		this.productForm = document.getElementById("product-form-" + this.dataset.section);
		this.prevValue = this.dataset.defaultValue;
		this.isRequired = this.dataset.required === "true";
		this.isText = true;
		this.notMain = this.dataset.notMain === "true";
		if (this.dataset.type === "select" || this.dataset.type === "pills") {
			this.isText = false;
		}
		this.createInputs();
		if (this.isRequired && this.isText) {
			this.isValid = true;
			this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc");
			this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section);
			this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
			this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
			this.atcErrorMsg = this.dataset.atcErrorMsg;
			this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
			this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
			this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
			this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
			if (this.applyStickyAtcError && this.stickyAtcButton) {
				this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
				this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
				this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
			}
			this.validateValue(this.prevValue, null);
		}
		if (this.input) {
			this.input.addEventListener("input", this.handleChange.bind(this));
		}
		this.inputRadios.forEach((_0x1873e7) => {
			_0x1873e7.addEventListener("input", this.handleChange.bind(this));
		});
		if (this.select) {
			this.select.addEventListener("change", this.handleChange.bind(this));
		}
	}
	["handleChange"](_0x15ef1f) {
		const _0x244984 = _0x15ef1f.target.value.trim();
		if (_0x15ef1f.target.checkValidity()) {
			this.prevValue = _0x244984;
		} else {
			_0x15ef1f.target.value = this.prevValue;
			return;
		}
		this.dataset.value = _0x244984;
		this.productFormInput.value = _0x244984;
		if (this.isRequired && this.isText) {
			this.validateValue(_0x244984, _0x15ef1f.target);
		}
	}
	["validateValue"](_0x3d56d1, _0x52e040) {
		const _0x187685 = !!(_0x3d56d1.length > 0);
		if (_0x187685 === this.isValid) {
			return;
		}
		this.isValid = _0x187685;
		if (_0x52e040) {
			if (this.isValid) {
				_0x52e040.classList.remove("input--error");
				this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1;
			} else {
				_0x52e040.classList.add("input--error");
				this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1;
			}
		}
		const _0x24515f = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
		const _0x167a31 = this.mainAtcButton.dataset.unavailable === "true";
		this.atcButtons.forEach((_0x345ffd) => {
			if (_0x24515f && !_0x167a31) {
				_0x345ffd.removeAttribute("disabled");
			} else {
				_0x345ffd.setAttribute("disabled", "");
			}
		});
		if (this.atcErrorMsg.length === 0) {
			return;
		}
		if (_0x24515f) {
			this.mainAtcBtnLabel.style.display = "";
			this.mainAtcBtnError.style.display = "none";
			if (this.applyStickyAtcError && this.stickyAtcButton) {
				this.stickyAtcBtnLabel.style.display = "";
				this.stickyAtcBtnError.style.display = "none";
			}
		} else {
			this.mainAtcBtnLabel.style.display = "none";
			this.mainAtcBtnError.style.display = "";
			if (this.applyStickyAtcError && this.stickyAtcButton) {
				this.stickyAtcBtnLabel.style.display = "none";
				this.stickyAtcBtnError.style.display = "";
			}
		}
	}
	["createInputs"]() {
		this.productFormInput = document.createElement("input");
		this.productFormInput.setAttribute("type", "hidden");
		this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]");
		this.productFormInput.value = this.dataset.defaultValue;
		this.productForm.appendChild(this.productFormInput);
	}
}
customElements.define("custom-product-field", CustomProductField);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.secondarySelectSelector = "StickyAtcVariantPicker-";
		this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
		this.isSecondary = false;
		this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
		this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
		this.prependMedia = this.dataset.disablePrepend != "true";
		this.filtering = this.dataset.hasFiltering === "true";
		this.skipNonExistent = this.dataset.skipNonExistent === "true";
		this.skipUnavailable = this.dataset.skipUnavailable === "true";
		if (this.hasQuantityBreaksPicker) {
			this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
			this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
		}
		this.addEventListener("change", this.onVariantChange);
	}
	["onVariantChange"]() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.updateVariantStatuses();
		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) {
				return;
			}
			this.setUnavailable();
		} else {
			if (this.skipUnavailable && !this.currentVariant.available) {
				if (findAvailableVariant(this, this.options, true, true, true)) {
					return;
				}
			}
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
		}
	}
	["updateOptions"]() {
		const _0x34e050 = [];
		this.querySelectorAll(".product-form__input").forEach((_0x56da17) => {
			let _0x3237f1;
			const _0x4b343f = _0x56da17.querySelector(".product-form__input__type").dataset.type;
			if (_0x4b343f == "dropdown" || _0x4b343f == "dropdwon") {
				_0x3237f1 = _0x56da17.querySelector(".select__select").value;
			} else {
				_0x3237f1 = _0x56da17.querySelector('input[type="radio"]:checked').value;
			}
			_0x34e050.push(_0x3237f1);
		});
		this.options = _0x34e050;
	}
	["updateMasterId"]() {
		this.currentVariant = this.getVariantData().find((_0x19b9fd) => {
			return !_0x19b9fd.options
				.map((_0x28bf81, _0xbd4e7f) => {
					return this.options[_0xbd4e7f] === _0x28bf81;
				})
				.includes(false);
		});
	}
	["updateMedia"]() {
		if (!this.currentVariant) {
			return;
		}
		if (!this.currentVariant.featured_media) {
			return;
		}
		const _0x53eaa6 = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
		_0x53eaa6.forEach((_0xece29a) => _0xece29a.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
		const _0x1a4730 = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
		if (!_0x1a4730) {
			return;
		}
		const _0x38af64 = _0x1a4730.querySelector('[data-media-id="' + this.currentVariant.featured_media.id + '"]');
		_0x1a4730.prepend(_0x38af64);
	}
	["updateURL"]() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") {
			return;
		}
		window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
	}
	["updateShareUrl"]() {
		const _0x20941f = document.getElementById("Share-" + this.dataset.section);
		if (!_0x20941f || !_0x20941f.updateUrl) {
			return;
		}
		_0x20941f.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
	}
	["updateVariantInput"]() {
		const _0x111a3c = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
		_0x111a3c.forEach((_0x59356e) => {
			const _0x3b0346 = _0x59356e.querySelector('input[name="id"]');
			_0x3b0346.value = this.currentVariant.id;
			_0x3b0346.dispatchEvent(
				new Event("change", {
					"bubbles": true,
				})
			);
		});
	}
	["updateVariantStatuses"]() {
		const _0x3c42b6 = this.variantData.filter((_0x11a641) => this.querySelector(":checked").value === _0x11a641.option1);
		let _0x24d69d;
		if (this.isSecondary && this.secondarySelect) {
			_0x24d69d = [...this.secondarySelect.querySelectorAll(".product-form__input")];
		} else {
			_0x24d69d = [...this.querySelectorAll(".product-form__input")];
		}
		_0x24d69d.forEach((_0x4c46fb, _0x3c0bb4) => {
			if (_0x3c0bb4 === 0) {
				return;
			}
			const _0x45a01a = [..._0x4c46fb.querySelectorAll('input[type="radio"], .select__select option')];
			const _0x222bfe = _0x24d69d[_0x3c0bb4 - 1].querySelector(":checked").value;
			const _0x2b8e2b = _0x3c42b6.filter((_0x2cbdf1) => _0x2cbdf1.available && _0x2cbdf1["option" + _0x3c0bb4] === _0x222bfe).map((_0x2a37cb) => _0x2a37cb["option" + (_0x3c0bb4 + 1)]);
			const _0x103e94 = _0x3c42b6.filter((_0x1bada5) => _0x1bada5["option" + _0x3c0bb4] === _0x222bfe).map((_0x4ced4b) => _0x4ced4b["option" + (_0x3c0bb4 + 1)]);
			this.setInputAvailability(_0x45a01a, _0x2b8e2b, _0x103e94);
		});
	}
	["setInputAvailability"](_0x268bd6, _0x2dcad8, _0x186c12) {
		_0x268bd6.forEach((_0x455db3) => {
			_0x455db3.classList.remove("unavailable", "non-existent", "disabled");
			const _0x38cd7f = _0x455db3.getAttribute("value");
			let _0x4a26ae = null;
			if (_0x455db3.dataset.swatch === "true") {
				_0x4a26ae = _0x455db3.closest(".color-swatch");
			}
			if (_0x4a26ae) {
				_0x4a26ae.classList.remove("unavailable", "non-existent", "disabled");
			}
			if (_0x186c12.includes(_0x38cd7f)) {
				if (_0x2dcad8.includes(_0x38cd7f)) {
					if (_0x455db3.nodeName === "OPTION") {
						_0x455db3.innerText = _0x38cd7f;
					} else {
						_0x455db3.classList.remove("disabled");
						if (_0x4a26ae) {
							_0x4a26ae.classList.remove("disabled");
						}
					}
				} else {
					if (_0x455db3.nodeName === "OPTION") {
						_0x455db3.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x38cd7f);
						_0x455db3.classList.add("unavailable");
					} else {
						_0x455db3.classList.add("disabled", "unavailable");
						if (_0x4a26ae) {
							_0x4a26ae.classList.add("disabled", "unavailable");
						}
					}
				}
			} else {
				if (_0x455db3.nodeName === "OPTION") {
					_0x455db3.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x38cd7f);
					_0x455db3.classList.add("non-existent");
				} else {
					_0x455db3.classList.add("disabled", "non-existent");
					if (_0x4a26ae) {
						_0x4a26ae.classList.add("disabled", "non-existent");
					}
				}
			}
		});
	}
	["updatePickupAvailability"]() {
		const _0x5deeb1 = document.querySelector("pickup-availability");
		if (!_0x5deeb1) {
			return;
		}
		if (this.currentVariant && this.currentVariant.available) {
			if (_0x5deeb1.fetchAvailability) {
				_0x5deeb1.fetchAvailability(this.currentVariant.id);
			}
		} else {
			_0x5deeb1.removeAttribute("available");
			_0x5deeb1.innerHTML = "";
		}
	}
	["removeErrorMessage"]() {
		const _0x353d70 = this.closest("section");
		if (!_0x353d70) {
			return;
		}
		const _0x39d7a1 = _0x353d70.querySelector("product-form");
		if (_0x39d7a1) {
			_0x39d7a1.handleErrorMessage();
		}
	}
	["renderProductInfo"]() {
		const _0x56ae7c = this.currentVariant.id;
		const _0x2dd349 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
		fetch(this.dataset.url + "?variant=" + _0x56ae7c + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section))
			.then((_0x4c5d9d) => _0x4c5d9d.text())
			.then((_0x5aa5fe) => {
				if (this.currentVariant.id !== _0x56ae7c) {
					return;
				}
				const _0x4ca522 = new DOMParser().parseFromString(_0x5aa5fe, "text/html");
				const _0x37e4fb = document.getElementById("price-" + this.dataset.section);
				const _0x124919 = _0x4ca522.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
				const _0x115032 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
				const _0x314422 = _0x4ca522.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
				const _0x4ee710 = document.getElementById("sticky-atc-price-" + this.dataset.section);
				const _0x7aa014 = _0x4ca522.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
				const _0x2ae7ea = document.getElementById("sticky-atc-image-" + this.dataset.section);
				const _0x4600eb = _0x4ca522.getElementById("sticky-atc-image-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
				const _0x40a655 = document.getElementById("main-atc-price-" + this.dataset.section);
				const _0x520413 = _0x4ca522.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
				const _0x33e492 = document.querySelectorAll('[id^="custom-label-' + this.dataset.section + '"]');
				const _0x3c68b3 = _0x4ca522.querySelectorAll('[id^="custom-label-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + '"]');
				const _0x51b67d = _0x4ca522.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
				const _0x270c9b = document.getElementById("Sku-" + this.dataset.section);
				const _0x48d522 = _0x4ca522.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
				const _0x4d5c38 = document.getElementById("Inventory-" + this.dataset.section);
				if (_0x37e4fb && _0x124919) {
					_0x37e4fb.innerHTML = _0x124919.innerHTML;
				}
				if (_0x115032 && _0x314422) {
					_0x115032.innerHTML = _0x314422.innerHTML;
				}
				if (_0x4ee710 && _0x7aa014) {
					_0x4ee710.innerHTML = _0x7aa014.innerHTML;
				}
				if (_0x2ae7ea && _0x4600eb) {
					_0x2ae7ea.src = _0x4600eb.src;
				}
				if (_0x520413 && _0x40a655) {
					_0x40a655.innerHTML = _0x520413.innerHTML;
				}
				if (_0x33e492 && _0x3c68b3) {
					for (var _0x364b28 = 0; _0x364b28 < _0x33e492.length; _0x364b28++) {
						_0x33e492[_0x364b28].innerHTML = _0x3c68b3[_0x364b28].innerHTML;
					}
				}
				if (_0x48d522 && _0x4d5c38) {
					_0x4d5c38.innerHTML = _0x48d522.innerHTML;
				}
				if (_0x51b67d && _0x270c9b) {
					_0x270c9b.innerHTML = _0x51b67d.innerHTML;
					_0x270c9b.classList.toggle("visibility-hidden", _0x51b67d.classList.contains("visibility-hidden"));
				}
				if (this.QuantityBreaks) {
					const _0x2e5987 = _0x4ca522.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
					const _0x50de3b = this.QuantityBreaks.querySelectorAll(".dynamic-price");
					const _0x1ed43a = _0x2e5987.querySelectorAll(".dynamic-price");
					for (let _0x1abc93 = 0; _0x1abc93 < _0x50de3b.length; _0x1abc93++) {
						_0x50de3b[_0x1abc93].innerHTML = _0x1ed43a[_0x1abc93].innerHTML;
					}
					if (this.QuantityBreaks.hasVariants) {
						this.QuantityBreaks.variantSelects.forEach((_0x545929) => {
							_0x545929.dataset.selectedId = this.currentVariant.id;
						});
						const _0x17f94f = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select");
						const _0x379b5a = _0x2e5987.querySelectorAll(".quantity-break__variant-select");
						for (let _0x4104e4 = 0; _0x4104e4 < _0x17f94f.length; _0x4104e4++) {
							_0x17f94f[_0x4104e4].innerHTML = _0x379b5a[_0x4104e4].innerHTML;
						}
						this.QuantityBreaks.initVariants();
					}
				}
				if (this.hasQuantityBreaksPicker) {
					const _0x17e812 = _0x4ca522.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
					const _0x3c38f9 = this.querySelectorAll(".dynamic-price");
					const _0x8be3cd = _0x17e812.querySelectorAll(".dynamic-price");
					for (let _0x5e6a19 = 0; _0x5e6a19 < _0x3c38f9.length; _0x5e6a19++) {
						_0x3c38f9[_0x5e6a19].innerHTML = _0x8be3cd[_0x5e6a19].innerHTML;
					}
					if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
						const _0x150fa1 = this.querySelectorAll(".quantity-break__image img");
						const _0x4cbbfa = _0x17e812.querySelectorAll(".quantity-break__image img");
						for (let _0x2b3c6a = 0; _0x2b3c6a < _0x150fa1.length; _0x2b3c6a++) {
							_0x150fa1[_0x2b3c6a].src = _0x4cbbfa[_0x2b3c6a].src;
						}
					}
				}
				if (this.secondarySelect) {
					const _0x30133b = _0x4ca522.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
					if (_0x30133b) {
						this.secondarySelect.innerHTML = _0x30133b.innerHTML;
					}
				}
				const _0x43eff5 = document.getElementById("price-" + this.dataset.section);
				if (_0x43eff5) {
					_0x43eff5.classList.remove("visibility-hidden");
				}
				if (_0x4d5c38) {
					_0x4d5c38.classList.toggle("visibility-hidden", _0x48d522.innerText === "");
				}
				const _0x221b7e = _0x4ca522.getElementById("ProductSubmitButton-" + _0x2dd349);
				this.toggleAddButton(_0x221b7e ? _0x221b7e.hasAttribute("disabled") : true, window.variantStrings.soldOut);
				publish("variant-change", {
					"data": {
						"sectionId": _0x2dd349,
						"html": _0x4ca522,
						"variant": this.currentVariant,
					},
				});
			});
	}
	["toggleAddButton"](_0x59f524 = true, _0x3274d8, _0x4c9c30 = true) {
		const _0x2c0fcd = document.getElementById("product-form-" + this.dataset.section);
		if (!_0x2c0fcd) {
			return;
		}
		const _0x5a1e0e = _0x2c0fcd.querySelector('[name="add"]');
		const _0x127996 = document.querySelectorAll(".main-product-atc");
		var _0x32eeb3 = _0x2c0fcd.querySelector(".main-atc__label__text");
		if (!_0x32eeb3) {
			_0x32eeb3 = _0x2c0fcd.querySelector(".main-atc__label");
		}
		const _0x31e64f = _0x2c0fcd.querySelector(".main-atc-price");
		if (!_0x5a1e0e) {
			return;
		}
		if (_0x59f524) {
			_0x5a1e0e.setAttribute("disabled", "disabled");
			_0x5a1e0e.setAttribute("data-unavailable", "true");
			if (_0x3274d8) {
				_0x32eeb3.textContent = _0x3274d8;
			}
			_0x127996.forEach((_0x17258e) => {
				_0x17258e.setAttribute("disabled", "disabled");
			});
			if (_0x31e64f) {
				_0x31e64f.classList.add("hidden");
			}
		} else {
			_0x5a1e0e.setAttribute("data-unavailable", "false");
			_0x32eeb3.textContent = window.variantStrings.addToCart;
			if (_0x31e64f) {
				_0x31e64f.classList.remove("hidden");
			}
			if (_0x5a1e0e.dataset.requiredFields === _0x5a1e0e.dataset.validFields) {
				_0x5a1e0e.removeAttribute("disabled");
				_0x127996.forEach((_0x9b28eb) => {
					_0x9b28eb.removeAttribute("disabled");
				});
			}
		}
		if (!_0x4c9c30) {
			return;
		}
	}
	["setUnavailable"]() {
		const _0x481f = document.getElementById("product-form-" + this.dataset.section);
		if (!_0x481f) {
			return;
		}
		const _0x5404b6 = _0x481f.querySelector('[name="add"]');
		var _0x1c3727 = _0x481f.querySelector(".main-atc__label__text");
		if (!_0x1c3727) {
			_0x1c3727 = _0x481f.querySelector(".main-atc__label");
		}
		const _0x1d51d0 = document.getElementById("price-" + this.dataset.section);
		const _0x27d9d6 = document.getElementById("Inventory-" + this.dataset.section);
		const _0x31a8d4 = document.getElementById("Sku-" + this.dataset.section);
		if (!_0x5404b6) {
			return;
		}
		_0x1c3727.textContent = window.variantStrings.unavailable;
		if (_0x1d51d0) {
			_0x1d51d0.classList.add("visibility-hidden");
		}
		if (_0x27d9d6) {
			_0x27d9d6.classList.add("visibility-hidden");
		}
		if (_0x31a8d4) {
			_0x31a8d4.classList.add("visibility-hidden");
		}
	}
	["getVariantData"]() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}
customElements.define("variant-selects", VariantSelects);

class SecondaryVariantSelect extends VariantSelects {
	constructor() {
		super();
		this.secondarySelectSelector = "variant-selects-";
		this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
		this.isSecondary = true;
	}
	["updateOptions"]() {
		this.options = this.querySelector("select").value.split(",");
	}
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);

class SecondaryVariantSelectSeparate extends VariantSelects {
	constructor() {
		super();
		this.secondarySelectSelector = "variant-selects-";
		this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
		this.isSecondary = true;
	}
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);

class CardVariantSelects extends VariantSelects {
	constructor() {
		super();
		this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
	}
	["onVariantChange"]() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updateVariantStatuses();
		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateVariantInput();
			this.updateQuickAddUrl();
			this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
		}
	}
	["updateMedia"]() {
		if (!this.currentVariant || !this.currentVariant.featured_media) {
			return;
		}
		const _0x36054b = document.getElementById(this.dataset.section + "-image");
		if (!_0x36054b) {
			return;
		}
		const _0x1b67db = this.currentVariant.featured_media.preview_image;
		const _0x29adb2 = _0x1b67db.src.split("?")[0];
		const _0x245839 = [0xa5, 0x168, 0x215, 0x2d0, 0x3ac, 0x42a];
		const _0x252982 = _0x245839
			.filter((_0x3d07c9) => _0x1b67db.width >= _0x3d07c9)
			.map((_0x5ee6e7) => _0x29adb2 + "?width=" + _0x5ee6e7 + " " + _0x5ee6e7 + "w")
			.join(", ");
		_0x36054b.srcset = _0x252982 + ", " + _0x29adb2 + " " + _0x1b67db.width + "w";
		_0x36054b.src = _0x29adb2 + "?width=533";
	}
	["updateQuickAddUrl"]() {
		if (!this.currentVariant || !this.quickAddSubmit) {
			return;
		}
		this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
	}
}
customElements.define("card-variant-selects", CardVariantSelects);
